/* Admin → Centro de QA: motor de la pantalla (lo monta CentroQa.vue).
   Sale de la demo aprobada (OneDrive\Desktop\herramienta-QA/app.js): mismo
   HTML y mismas reglas; lo que cambió es la capa de datos, que ahora es la API
   (QaController, admin/qa…).

   Ciclo de una integración: pendiente → corrida de prueba (dry-run) → QA revisa
   y corrige → Integrar → aprobada → QA elige la hora y la habilita → corre sola.
   Lo que QA decide en la revisión se guarda solo (PATCH por alojamiento) y al
   integrar queda como regla que los syncs respetan siempre.

   Las reglas de clasificar() y estadoCampo() son las mismas que
   App\Services\Qa\Revisores\ReglasRevisor de la API: si se cambia una, la otra.

   montar(raiz, { api, navegar }) → { ir(vista), ocupado(), destruir() }
     api.get/post/patch(ruta, body) → data   (lanza { status, data } si falla)
     navegar('' | 'historial' | <clave> | 'admin')   cambia la URL */
export function montar(raiz, opciones) {
'use strict';
const api = opciones.api;

// ── Utilidades ─────────────────────────────────────────────────────────
const $ = (s, r = raiz) => r.querySelector(s);
const ESC = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };
const esc = s => String(s == null ? '' : s).replace(/[&<>"']/g, c => ESC[c]);
const nf = new Intl.NumberFormat('es-CL');
const num = n => nf.format(Math.round(n || 0));
const plural = (n, uno, varios) => `${num(n)} ${n === 1 ? uno : varios}`;
const SIMBOLO = { CLP: '$', USD: 'US$', EUR: '€', GBP: '£', ARS: 'ARS $' };
const dinero = (n, cur) => `${SIMBOLO[cur] || cur} ${num(n)}`;
/** Monedas con fila en `tipo_cambio` (config qa.monedas): lo demás entra oculto. */
const MONEDAS_OK = ['USD', 'GBP', 'EUR', 'CLP'];
const aFecha = s => (s ? new Date(String(s).replace(' ', 'T')) : null);
const fecha = s => { const d = aFecha(s); return d ? d.toLocaleDateString('es-CL', { day: '2-digit', month: '2-digit' }) + ' ' + d.toLocaleTimeString('es-CL', { hour: '2-digit', minute: '2-digit' }) : '—'; };
const msgErr = e => (e && e.data && e.data.message) || (e && e.status === 0 ? 'No hay conexión con el servidor.' : 'Algo salió mal. Vuelve a intentarlo.');

// ── Íconos ─────────────────────────────────────────────────────────────
const svg = d => `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">${d}</svg>`;
const I = {
    play: svg('<path d="M7 4.5v15l12-7.5z"/>'),
    user: svg('<circle cx="12" cy="8" r="4"/><path d="M4 21a8 8 0 0 1 16 0"/>'),
    spark: svg('<path d="M12 3l1.8 4.7L18.5 9.5l-4.7 1.8L12 16l-1.8-4.7L5.5 9.5l4.7-1.8z"/><path d="M19 15l.8 2.2L22 18l-2.2.8L19 21l-.8-2.2L16 18l2.2-.8z"/>'),
    chevR: svg('<path d="m9 6 6 6-6 6"/>'), chevL: svg('<path d="m15 6-6 6 6 6"/>'),
    back: svg('<path d="M19 12H5M11 18l-6-6 6-6"/>'),
    search: svg('<circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/>'),
    img: svg('<rect x="3" y="4" width="18" height="16" rx="3"/><circle cx="9" cy="10" r="2"/><path d="m21 16-5-5-9 9"/>'),
    alert: svg('<path d="M12 9v4M12 17h.01"/><path d="M10.3 3.9 2.4 17.5A2 2 0 0 0 4.1 20.5h15.8a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0z"/>'),
    coin: svg('<circle cx="12" cy="12" r="9"/><path d="M14.5 9.5c-.5-1-1.5-1.5-2.5-1.5-1.4 0-2.5.8-2.5 2s1.1 1.7 2.5 2 2.5.8 2.5 2-1.1 2-2.5 2c-1 0-2-.5-2.5-1.5M12 6.5v1.5M12 16v1.5"/>'),
    text: svg('<path d="M4 6h16M4 12h10M4 18h13"/>'),
    phone: svg('<path d="M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3.1 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.1 4.2 2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7c.1 1 .4 1.9.7 2.8a2 2 0 0 1-.5 2.1L8 9.9a16 16 0 0 0 6 6l1.3-1.3a2 2 0 0 1 2.1-.4c.9.3 1.8.6 2.8.7a2 2 0 0 1 1.7 2z"/>'),
    list: svg('<path d="M9 6h11M9 12h11M9 18h11M4.5 6h.01M4.5 12h.01M4.5 18h.01"/>'),
    pin: svg('<path d="M12 21s-7-6.1-7-11.5a7 7 0 0 1 14 0C19 14.9 12 21 12 21z"/><circle cx="12" cy="9.5" r="2.5"/>'),
    grid: svg('<rect x="3" y="3" width="7" height="7" rx="2"/><rect x="14" y="3" width="7" height="7" rx="2"/><rect x="3" y="14" width="7" height="7" rx="2"/><rect x="14" y="14" width="7" height="7" rx="2"/>'),
    clock: svg('<circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/>'),
    check: svg('<path d="m5 12.5 4.5 4.5L19 7.5"/>'),
    shield: svg('<path d="M12 3 4.5 6v5.5c0 4.6 3.2 8.4 7.5 9.5 4.3-1.1 7.5-4.9 7.5-9.5V6z"/><path d="m8.5 12 2.5 2.5 4.5-5"/>'),
    trash: svg('<path d="M4 7h16M10 11v6M14 11v6M6 7l1 12a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2l1-12M9 7V4h6v3"/>'),
    refresh: svg('<path d="M20 11a8 8 0 0 0-14.9-3.5M4 4v4h4M4 13a8 8 0 0 0 14.9 3.5M20 20v-4h-4"/>'),
    upload: svg('<path d="M12 16V4M7 9l5-5 5 5M4 16v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2"/>'),
    info: svg('<circle cx="12" cy="12" r="9"/><path d="M12 11v5M12 8h.01"/>'),
    pause: svg('<path d="M9 5v14M15 5v14"/>'),
    copy: svg('<rect x="9" y="9" width="12" height="12" rx="2.5"/><path d="M5 15H4.5A1.5 1.5 0 0 1 3 13.5v-9A1.5 1.5 0 0 1 4.5 3h9A1.5 1.5 0 0 1 15 4.5V5"/>'),
};

// ── Campos de la ficha ─────────────────────────────────────────────────
const TEXTOS = { reglas: 'Reglas', espacios_comunes: 'Espacios comunes', aseo_limpieza: 'Aseo y limpieza', uso_cocina: 'Uso de cocina', sobre_nosotros: 'Sobre nosotros' };
const CAMPOS_TXT = Object.keys(TEXTOS);
const CAMPOS = [
    { k: 'fotos', t: 'Fotos' }, { k: 'precio', t: 'Precio' }, { k: 'ubicacion', t: 'Ubicación' }, { k: 'amenidades', t: 'Amenidades' }, { k: 'camas', t: 'Camas y baños' },
    ...CAMPOS_TXT.map(k => ({ k, t: TEXTOS[k] })),
];
// Lo que puede marcar en una foto un revisor (hoy ninguno: el agente de fotos se suma después).
const DEFECTOS = {
    borrosa: 'Borrosa', oscura: 'Muy oscura', marca_agua: 'Marca de agua', captura: 'Captura de pantalla',
    plano: 'Plano, no es foto', repetida: 'Repetida', baja_resolucion: 'Baja resolución', no_es_alojamiento: 'No muestra el alojamiento',
};
const BADGE_E = { ok: 'bk-badge--ok', warn: 'bk-badge--wait', bad: 'bk-badge--bad' };
const TXT_E = { ok: 'Bien', warn: 'Revisar', bad: 'Corregir' };
const MARCA_E = { ok: '✓', warn: '!', bad: '✕' };

// Mismas reglas que ReglasRevisor (API).
const RELLENO = ['NINGUNA', 'NINGUNO', '-', '.', 'N/A', 'NA', 'VER REGLAS', 'SIN REGLAS'];
const MIN_TEXTO = 20;
const RE_TEL = /\+?\d[\d\s]{7,}\d/;
const RE_MAIL = /[\w.+-]+@[\w-]+\.[\w.]+/;
const PALABRAS_EN = new Set(['the', 'and', 'with', 'of', 'to', 'is', 'after', 'shared', 'room', 'kitchen', 'included', 'weekly', 'fully', 'close', 'perfect', 'for', 'smoking', 'quiet', 'hours', 'parties', 'city', 'views', 'cleaning', 'living', 'bright', 'flat', 'students', 'you', 'your', 'are', 'our', 'we', 'house', 'bedroom', 'bathroom', 'available']);
function clasificar(valor) {
    const t = String(valor || '').trim();
    if (!t) return 'vacio';
    if (RELLENO.includes(t.toUpperCase()) || t.length < MIN_TEXTO) return 'corto';
    if (RE_TEL.test(t) || RE_MAIL.test(t)) return 'contacto';
    const pal = t.toLowerCase().match(/[a-záéíóúñü]+/g) || [];
    if (pal.length && pal.filter(p => PALABRAS_EN.has(p)).length / pal.length > 0.3) return 'ingles';
    return 'ok';
}
const PISTA = {
    vacio: { e: 'warn', t: 'Escribe el texto que va a mostrar la ficha.' },
    corto: { e: 'warn', t: `Muy corto: escribe al menos ${MIN_TEXTO} caracteres.` },
    contacto: { e: 'bad', t: 'Tiene un teléfono o un correo: quítalo antes de guardar.' },
    ingles: { e: 'warn', t: 'Parece estar en inglés. En este campo va en español.' },
    ok: { e: 'ok', t: '✓ Se ve bien.' },
};
const pista = v => { const p = PISTA[clasificar(v)]; return `<span class="is-${p.e}">${p.t}</span>`; };
/** Saca las oraciones que tienen un teléfono o un correo. */
// Sin lookbehind en la regex: Safari < 16.4 no lo entiende y rompería toda la pantalla.
const sinContacto = texto => (String(texto || '').match(/[^.!?\n]+[.!?\n]*/g) || []).map(o => o.trim()).filter(o => o && !RE_TEL.test(o) && !RE_MAIL.test(o)).join(' ').trim();
const marcar = texto => esc(texto).replace(/(\+?\d[\d\s]{7,}\d)/g, '<mark>$1</mark>').replace(/([\w.+-]+@[\w-]+\.[\w.]+)/g, '<mark>$1</mark>');

// ── Estado ─────────────────────────────────────────────────────────────
const S = {
    vista: 'inicio', clave: null,
    // "Ver integración": lo que hay hoy en la base (S.c sin id). No se excluye ni
    // se integra nada; los textos y amenidades se corrigen en vivo (enVivo).
    soloVer: false,
    ints: null, hist: null, c: null,      // c = corrida en revisión (con items)
    cargando: false, error: '',
    inicio: { filtro: 'todas', q: '' },
    rev: { filtro: 'todos', hallazgo: null, q: '', max: 60 },
    capa: null, focoPrevio: null, vistaPrevia: '',
    deshacer: null,
};
const pendientes = new Map();   // item id → timeout del guardado
let enVuelo = 0;                 // PATCH en camino
let pollInts = null, pollCapa = null, seqRuta = 0;
const intDe = clave => (S.ints || []).find(i => i.clave === clave);

// ── Adaptar lo que manda la API a la forma de la demo ──────────────────
function adaptarItem(x) {
    const d = x.datos || {}, dec = x.decision || {};
    const quit = new Set(dec.fotos_quitadas || []), oks = new Set(dec.fotos_ok || []);
    const porFoto = {};
    (x.hallazgos || []).forEach(h => { if (h.foto) porFoto[h.foto] = h; });
    const fotos = (d.fotos || []).map((src, k) => {
        const h = porFoto[k + 1];
        return { id: `${x.id}-${k}`, src, defecto: h ? h.codigo : null, detalle: h ? h.detalle : '', igualA: h && h.igual_a ? h.igual_a : null, quitada: quit.has(src), aceptada: oks.has(src) };
    });
    const textos = {};
    CAMPOS_TXT.forEach(k => {
        const orig = (d.textos && d.textos[k]) || '';
        const tuyo = dec.textos && typeof dec.textos[k] === 'string' && dec.textos[k].trim() !== orig.trim();
        const valor = tuyo ? dec.textos[k] : orig;
        textos[k] = { original: orig, vOrig: clasificar(orig), valor, editado: tuyo, v: clasificar(valor), copiadoDe: null };
    });
    const lista = d.amenidades || [];
    const amenOrig = lista.filter(a => a.v).map(a => a.col);
    const cambios = dec.amenidades && !Array.isArray(dec.amenidades) ? dec.amenidades : {};
    const columnas = lista.map(a => a.col).filter(col => (col in cambios ? !!cambios[col] : amenOrig.includes(col)));
    // Camas, baños, capacidad y quiénes viven: { col: número }.
    const cantLista = d.cantidades || [];
    const cantOrig = {}, cant = {};
    const decCant = dec.cantidades && !Array.isArray(dec.cantidades) ? dec.cantidades : {};
    cantLista.forEach(c => { cantOrig[c.col] = +c.v || 0; cant[c.col] = c.col in decCant ? +decCant[c.col] || 0 : cantOrig[c.col]; });
    return {
        id: x.id, idcodigo: x.idcodigo, idalojamiento: x.idalojamiento, accion: x.accion,
        nombre: d.nombre || x.idcodigo, direccion: d.direccion || '', coords: !!d.coords, tipo: d.tipo || '', modalidad: d.modalidad || 'Mensual',
        moneda: d.moneda || 'CLP', precio: +d.precio || 0, garantia: +d.garantia || 0, huespedes: d.huespedes, m2: d.m2, publicado: d.publicado !== false,
        fotos, textos, amenLista: lista, amenOrig, columnas, sinColumna: d.sin_columna || [],
        cantLista, cantOrig, cant,
        hall: x.hallazgos || [], incluido: dec.incluido !== false, visto: !!dec.visto,
        // "Ver integración": columnas que QA ya corrigió a mano (las corridas no las tocan).
        fijados: new Set(d.fijados || []),
    };
}
function decisionDe(it) {
    const textos = {}, amenidades = {}, cantidades = {};
    CAMPOS_TXT.forEach(k => { if (it.textos[k].editado) textos[k] = it.textos[k].valor; });
    cambiosCant(it).forEach(c => { cantidades[c] = it.cant[c]; });
    it.amenLista.forEach(a => { const on = it.columnas.includes(a.col); if (on !== it.amenOrig.includes(a.col)) amenidades[a.col] = on ? 1 : 0; });
    return {
        incluido: it.incluido, visto: it.visto,
        fotos_quitadas: it.fotos.filter(f => f.quitada).map(f => f.src),
        fotos_ok: it.fotos.filter(f => f.aceptada).map(f => f.src),
        textos, amenidades, cantidades,
    };
}
/** Guarda la decisión del alojamiento (con un respiro: varios clics seguidos = un solo PATCH). */
function guardar(it) {
    if (!S.c || !S.c.id) return;   // en "Ver integración" no se guarda nada
    const cid = S.c.id;
    clearTimeout(pendientes.get(it.id));
    pendientes.set(it.id, setTimeout(() => enviar(cid, it), 600));
    pintarBarra();
}
function enviar(cid, it) {
    pendientes.delete(it.id);
    enVuelo++;
    pintarBarra();
    return api.patch(`/corridas/${cid}/items/${it.id}`, { decision: decisionDe(it) })
        .catch(e => aviso(`No se guardó un cambio en ${it.nombre}: ${msgErr(e)}`, null, true))
        .then(() => { enVuelo--; pintarBarra(); });
}
/** Manda ya todo lo que esté esperando (antes de integrar o de salir). */
function vaciarPendientes() {
    const it = id => S.c && S.c.items.find(x => x.id === id);
    const promesas = [];
    pendientes.forEach((tm, id) => { clearTimeout(tm); const x = it(id); if (x) promesas.push(enviar(S.c.id, x)); });
    pendientes.clear();
    return Promise.all(promesas);
}

// ── Reglas de la revisión ──────────────────────────────────────────────
const fotosActivas = it => it.fotos.filter(f => !f.quitada);
const fotosMarcadas = it => it.fotos.filter(f => f.defecto && !f.quitada && !f.aceptada);
function preciosPorMoneda(items) {
    const m = {};
    items.forEach(it => { if (it.precio) (m[it.moneda] = m[it.moneda] || []).push(it.precio); });
    return Object.entries(m).map(([cur, v]) => ({
        cur, n: v.length, media: v.reduce((a, b) => a + b, 0) / v.length, min: Math.min(...v), max: Math.max(...v), ok: MONEDAS_OK.includes(cur),
    })).sort((a, b) => b.n - a.n);
}
const cambiosAmen = it => ({ agregadas: it.columnas.filter(a => !it.amenOrig.includes(a)), quitadas: it.amenOrig.filter(a => !it.columnas.includes(a)) });
const etiquetaAmen = (it, col) => { const a = it.amenLista.find(x => x.col === col); return a ? a.t : col; };
const cambiosCant = it => it.cantLista.map(c => c.col).filter(c => it.cant[c] !== it.cantOrig[c]);
const etiquetaCant = (it, col) => { const c = it.cantLista.find(x => x.col === col); return c ? c.t : col; };
const sumaCant = (it, g) => it.cantLista.filter(c => c.g === g).reduce((a, c) => a + (it.cant[c.col] || 0), 0);
const textosEditados = it => CAMPOS_TXT.filter(k => it.textos[k].editado).length;
const editado = it => textosEditados(it) > 0 || cambiosAmen(it).agregadas.length + cambiosAmen(it).quitadas.length > 0 || cambiosCant(it).length > 0 || it.fotos.some(f => f.quitada);

/** Estado de un campo: { e: 'ok' | 'warn' | 'bad', corto, nota } */
function estadoCampo(it, k) {
    if (k === 'fotos') {
        const act = fotosActivas(it), mal = fotosMarcadas(it), quit = it.fotos.length - act.length;
        if (!act.length) return { e: 'bad', corto: 'Sin fotos', nota: 'No le queda ninguna foto: <b>entraría oculto</b>.' };
        if (mal.length) return { e: 'bad', corto: `${mal.length} marcada${mal.length > 1 ? 's' : ''}`, nota: `Hay <b>${plural(mal.length, 'foto marcada', 'fotos marcadas')}</b>. Quítalas o márcalas como correctas.` };
        if (act.length < 4) return { e: 'warn', corto: `Solo ${act.length}`, nota: `Le quedan <b>${plural(act.length, 'foto', 'fotos')}</b>. Las fichas con menos de 4 reciben menos consultas.` };
        if (S.soloVer) return { e: 'ok', corto: quit ? `${quit} quitada${quit > 1 ? 's' : ''}` : '', nota: quit ? `Tiene ${act.length} fotos. Quitaste ${quit}: no vuelven aunque la integración corra sola.` : `Tiene ${act.length} fotos cargadas. Puedes quitar las que no sirvan: no vuelven aunque la integración corra sola.` };
        return { e: 'ok', corto: quit ? `${quit} quitada${quit > 1 ? 's' : ''}` : '', nota: quit ? `Se suben ${act.length} y se quitan ${quit}.` : `Se suben las ${act.length} fotos.` };
    }
    if (k === 'precio') {
        const h = it.hall.find(x => x.campo === 'precio');
        if (!h) return { e: 'ok', corto: '', nota: 'En línea con la media de la corrida.' };
        const corto = { moneda: it.moneda, sin_precio: 'Sin precio', precio_alto: 'Muy alto', precio_bajo: 'Muy bajo' }[h.codigo] || 'Revisar';
        return { e: h.e, corto, nota: esc(h.detalle) };
    }
    if (k === 'ubicacion') {
        return it.coords ? { e: 'ok', corto: '', nota: '' } : { e: 'bad', corto: 'Sin coordenadas', nota: 'No trae coordenadas: no aparece en el mapa ni en las búsquedas por zona, y <b>entraría oculto</b>.' };
    }
    if (k === 'amenidades') {
        const { agregadas, quitadas } = cambiosAmen(it);
        const tuyas = agregadas.length || quitadas.length;
        const n = it.columnas.length;
        if (!it.amenLista.length) return { e: 'ok', corto: '', nota: 'Esta integración no maneja amenidades.' };
        if (!n) return { e: 'bad', corto: 'Ninguna', nota: 'El feed no trae ninguna amenidad que HyF entienda. <b>Marca abajo las que tiene</b>.' };
        if (n < 3) return { e: 'warn', corto: `Solo ${n}`, nota: 'Trae pocas amenidades. Si sabes que tiene más, <b>agrégalas abajo</b>.' };
        const tu = tuyas ? ` ${agregadas.length ? `Agregaste <b>${esc(agregadas.map(a => etiquetaAmen(it, a)).join(', '))}</b>.` : ''}${quitadas.length ? ` Quitaste <b>${esc(quitadas.map(a => etiquetaAmen(it, a)).join(', '))}</b>.` : ''}` : '';
        const sin = it.sinColumna.length ? ` <b>${esc(it.sinColumna.join(', '))}</b> no tiene${it.sinColumna.length > 1 ? 'n' : ''} columna en HyF: no se va${it.sinColumna.length > 1 ? 'n' : ''} a mostrar.` : '';
        return { e: 'ok', corto: tuyas ? 'Editadas' : '', nota: `Se cargan ${n} amenidades.${tu}${sin}` };
    }
    if (k === 'camas') {
        if (!it.cantLista.length) return { e: 'ok', corto: '', nota: '' };
        const camas = sumaCant(it, 'Camas'), banos = sumaCant(it, 'Baños'), tuyas = cambiosCant(it);
        const tu = tuyas.length ? ` Cambiaste <b>${esc(tuyas.map(c => etiquetaCant(it, c)).join(', '))}</b>.` : '';
        if (!camas) return { e: 'bad', corto: 'Sin camas', nota: `No tiene camas cargadas: la ficha no dice dónde se duerme. <b>Súmalas abajo</b>.${tu}` };
        if (!banos) return { e: 'warn', corto: 'Sin baño', nota: `No dice si el baño es privado o compartido.${tu}` };
        return { e: 'ok', corto: tuyas.length ? 'Editado' : '', nota: `${plural(camas, 'cama', 'camas')} y ${plural(banos, 'baño', 'baños')}.${tu}` };
    }
    const t = it.textos[k];
    if (!t) return { e: 'ok', corto: '', nota: '' };
    if (t.editado && t.v === 'ok' && t.copiadoDe) {
        const de = S.c.items.find(i => i.id === t.copiadoDe);
        return { e: 'ok', corto: 'Copiado', nota: `Lo copiaste de <b>${esc(de ? de.nombre : 'otro alojamiento')}</b>. Revisa que sirva también para este.` };
    }
    if (S.soloVer && it.fijados.has(k) && t.v === 'ok') return { e: 'ok', corto: 'Fijado', nota: 'Lo corregiste a mano: queda así aunque la integración corra sola y el feed traiga otra cosa o venga vacío.' };
    if (t.editado && t.v === 'ok') return { e: 'ok', corto: 'Editado', nota: 'Lo corregiste en la revisión: al integrar se traduce a los demás idiomas y queda fijo, aunque el feed traiga otra cosa.' };
    switch (t.v) {
        case 'vacio': return { e: 'bad', corto: 'Vacío', nota: 'El feed no trae este texto: la sección queda vacía en la ficha.' };
        case 'corto': return { e: 'warn', corto: 'Relleno', nota: `Dice "<b>${esc(t.valor)}</b>": es texto de relleno, no sirve para la ficha.` };
        case 'ingles': return { e: 'warn', corto: 'En inglés', nota: 'Está en <b>inglés</b> en el campo de español.' };
        case 'contacto': return { e: 'bad', corto: 'Datos de contacto', nota: 'Trae un <b>teléfono o un correo</b>. En HyF los datos de contacto no se muestran antes del pago.' };
        default: return { e: 'ok', corto: '', nota: 'Texto completo y en español.' };
    }
}
const estados = it => CAMPOS.map(x => ({ ...x, ...estadoCampo(it, x.k) }));
const observaciones = it => estados(it).filter(x => x.e !== 'ok');
function publicable(it) {
    if (!MONEDAS_OK.includes(it.moneda)) return { ok: false, motivo: `moneda ${it.moneda}` };
    if (!it.precio) return { ok: false, motivo: 'sin precio' };
    if (!fotosActivas(it).length) return { ok: false, motivo: 'sin fotos' };
    if (!it.coords) return { ok: false, motivo: 'sin coordenadas' };
    if (!it.publicado) return { ok: false, motivo: S.soloVer ? 'oculto en HyF' : 'el feed lo marca no disponible' };
    return { ok: true };
}
const paraCompletar = i => CAMPOS_TXT.some(k => i.textos[k].v !== 'ok') || estadoCampo(i, 'amenidades').e !== 'ok' || estadoCampo(i, 'camas').e !== 'ok';

function resumen(c) {
    const inc = c.items.filter(i => i.incluido);
    return {
        total: c.items.length, incluidos: inc.length, excluidos: c.items.length - inc.length,
        nuevos: inc.filter(i => i.accion === 'nuevo').length, actualiza: inc.filter(i => i.accion !== 'nuevo').length,
        publican: inc.filter(i => publicable(i).ok).length, ocultos: inc.filter(i => !publicable(i).ok).length,
        pendientes: c.items.reduce((a, i) => a + fotosMarcadas(i).length, 0),
        quitadas: inc.reduce((a, i) => a + i.fotos.filter(f => f.quitada).length, 0),
        textos: inc.reduce((a, i) => a + textosEditados(i), 0),
        amen: inc.reduce((a, i) => a + cambiosAmen(i).agregadas.length + cambiosAmen(i).quitadas.length, 0),
        cant: inc.reduce((a, i) => a + cambiosCant(i).length, 0),
        completar: c.items.filter(paraCompletar).length,
        conObs: c.items.filter(i => observaciones(i).length).length,
        vistos: c.items.filter(i => i.visto).length,
    };
}

const FILTROS_HALLAZGO = {
    fotos: i => fotosMarcadas(i).length > 0,
    pocas: i => estadoCampo(i, 'fotos').e !== 'ok' && !fotosMarcadas(i).length,
    precio: i => estadoCampo(i, 'precio').e !== 'ok' && MONEDAS_OK.includes(i.moneda),
    moneda: i => !MONEDAS_OK.includes(i.moneda),
    ubicacion: i => !i.coords,
    contacto: i => CAMPOS_TXT.some(k => i.textos[k].v === 'contacto'),
    textos: i => CAMPOS_TXT.some(k => ['vacio', 'corto', 'ingles'].includes(i.textos[k].v)),
    amenidades: i => estadoCampo(i, 'amenidades').e !== 'ok',
    camas: i => estadoCampo(i, 'camas').e !== 'ok',
};
const NOMBRE_HALLAZGO = { fotos: 'Fotos marcadas', pocas: 'Pocas fotos', precio: 'Precios raros', moneda: 'Moneda no aceptada', ubicacion: 'Sin coordenadas', contacto: 'Datos de contacto', textos: 'Textos incompletos', amenidades: 'Amenidades', camas: 'Camas y baños' };
function hallazgos(c) {
    const h = [], cuenta = f => c.items.filter(FILTROS_HALLAZGO[f]);
    const fo = cuenta('fotos');
    if (fo.length) h.push({ f: 'fotos', e: 'bad', ico: I.img, t: plural(fo.reduce((a, i) => a + fotosMarcadas(i).length, 0), 'foto marcada', 'fotos marcadas'), d: `En ${plural(fo.length, 'alojamiento', 'alojamientos')}.` });
    const po = cuenta('pocas');
    if (po.length) h.push({ f: 'pocas', e: 'warn', ico: I.img, t: `${plural(po.length, 'alojamiento', 'alojamientos')} con pocas fotos`, d: 'Menos de 4, o ninguna.' });
    const pr = cuenta('precio');
    if (pr.length) h.push({ f: 'precio', e: 'warn', ico: I.coin, t: plural(pr.length, 'precio raro', 'precios raros'), d: 'Muy lejos de la media de la corrida, o en 0.' });
    const mo = cuenta('moneda');
    if (mo.length) h.push({ f: 'moneda', e: 'bad', ico: I.coin, t: `${plural(mo.length, 'alojamiento', 'alojamientos')} en ${[...new Set(mo.map(i => i.moneda))].join(', ')}`, d: 'Moneda sin tipo de cambio en HyF: entrarían ocultos.' });
    const ub = cuenta('ubicacion');
    if (ub.length) h.push({ f: 'ubicacion', e: 'bad', ico: I.pin, t: `${plural(ub.length, 'alojamiento', 'alojamientos')} sin coordenadas`, d: 'No aparecen en el mapa: entrarían ocultos.' });
    const co = cuenta('contacto');
    if (co.length) h.push({ f: 'contacto', e: 'bad', ico: I.phone, t: `${plural(co.length, 'texto', 'textos')} con datos de contacto`, d: 'Teléfonos o correos dentro de la descripción.' });
    const tx = cuenta('textos');
    if (tx.length) h.push({ f: 'textos', e: 'warn', ico: I.text, t: `${plural(tx.length, 'alojamiento', 'alojamientos')} con textos incompletos`, d: 'Vacíos, de relleno o en inglés. Se completan desde la ficha.' });
    const am = cuenta('amenidades');
    if (am.length) h.push({ f: 'amenidades', e: 'warn', ico: I.list, t: `${plural(am.length, 'alojamiento', 'alojamientos')} con amenidades a revisar`, d: 'Sin ninguna o con muy pocas. Se agregan desde la ficha.' });
    const ca = cuenta('camas');
    if (ca.length) h.push({ f: 'camas', e: 'warn', ico: I.list, t: `${plural(ca.length, 'alojamiento', 'alojamientos')} sin camas o sin baño`, d: 'Se completan desde la ficha, en "Camas, baños y capacidad".' });
    if (!h.length) h.push({ f: null, e: 'ok', ico: I.check, t: 'Todo en orden', d: 'La revisión automática no encontró nada raro.' });
    return h;
}

// ── Piezas comunes ─────────────────────────────────────────────────────
const logo = int => `<span class="qa-logo" style="--c:${int.color}" aria-hidden="true">${esc(int.corto)}</span>`;
/**
 * URL pública de una foto, con la misma regla que el resto del sitio
 * (normalizeS3ImageUrl en Carousel*.vue): un nombre de archivo va al bucket
 * (VUE_APP_S3_URL) y a una URL de S3 sin el bucket se le agrega.
 * Solo devuelve http(s): las fotos vienen de feeds externos y van a un
 * href, así que un "javascript:…" no puede pasar.
 */
function urlFoto(src) {
    const url = armarUrlFoto(String(src || '').trim());
    return /^https?:\/\//i.test(url) ? url : '';
}
function armarUrlFoto(src) {
    if (!src) return '';
    if (src.indexOf('http') === -1) return (process.env.VUE_APP_S3_URL || '') + src;
    const bucket = (process.env.VUE_APP_AWS_BUCKET_URL || '').replace(/^\/+|\/+$/g, '');
    if (!bucket || src.indexOf('s3-sa-east-1.amazonaws.com') === -1 || src.indexOf(bucket) > -1) return src;
    try { const u = new URL(src); u.pathname = `/${bucket}/${u.pathname.replace(/^\/+/, '')}`; return u.toString(); } catch (e) { return src; }
}
const imagen = f => `<span class="qa-img"><img src="${esc(urlFoto(f.src))}" alt="" loading="lazy" decoding="async" referrerpolicy="no-referrer" onerror="this.style.visibility='hidden'" /></span>`;
function nav(activa) {
    const items = [{ v: '', t: 'Integraciones', ico: I.grid, k: 'inicio' }, { v: 'historial', t: 'Historial', ico: I.clock, k: 'historial' }];
    return `<nav class="bk-snav" aria-label="Centro de QA">
        <p class="bk-snav-title">Centro de QA</p>
        <ul class="bk-snav-list">${items.map(i => `<li><a href="/admin/centro-qa${i.v ? '/' + i.v : ''}" data-nav="${i.v}" class="bk-snav-link${i.k === activa ? ' is-active' : ''}"${i.k === activa ? ' aria-current="page"' : ''}>${i.ico}<span>${i.t}</span></a></li>`).join('')}</ul>
    </nav>`;
}
const crumb = txt => `<p class="qa-crumb"><a href="/admin" data-nav="admin">Administrador</a>${I.chevR}<span>${esc(txt)}</span></p>`;
// Lo que se ve mientras carga es el loader de House & Flats (CentroQa.vue,
// ver estadoCarga); acá solo queda el lugar vacío.
const cargandoHtml = () => '<div class="qa-cargando" aria-hidden="true"></div>';

/** "Cada hora", "Cada 30 minutos": para las integraciones que no corren una vez al día. */
const cadaTxt = m => (m % 60 === 0 ? (m === 60 ? 'Cada hora' : `Cada ${m / 60} horas`) : `Cada ${m} minutos`);

/** "todos los días a las" o "cada hora desde las", antes de la hora. */
const frecuencia = int => (int.cada_minutos ? `${cadaTxt(int.cada_minutos).toLowerCase()} desde las` : 'todos los días a las');

/** Estado que se muestra de una integración (el de la base, o lo que está pasando ahora). */
function estadoInt(int) {
    if (int.en_curso) return 'corriendo';
    if (int.en_revision) return 'revision';
    return int.estado;
}
const BADGE_INT = {
    corriendo: '<span class="bk-badge bk-badge--wait">Corriendo</span>',
    revision: '<span class="bk-badge bk-badge--rev">En revisión</span>',
    pendiente: '<span class="bk-badge bk-badge--wait">Pendiente</span>',
    aprobada: '<span class="bk-badge bk-badge--azul">Lista para habilitar</span>',
    habilitada: '<span class="bk-badge bk-badge--ok">Automática</span>',
    pausada: '<span class="bk-badge bk-badge--plain">Pausada</span>',
};
const TIPO_TXT = { prueba: 'Prueba', integracion: 'Integración', manual: 'Manual', automatica: 'Automática' };

// ── Vista: Centro de QA ────────────────────────────────────────────────
function vInicio() {
    if (!S.ints) return S.error ? errorHtml() : cargandoHtml('Cargando integraciones…');
    const s = S.inicio;
    const est = int => estadoInt(int);
    const cuenta = f => S.ints.filter(f).length;
    const F = {
        todas: () => true,
        pendientes: i => ['pendiente', 'aprobada'].includes(est(i)),
        revision: i => ['revision', 'corriendo'].includes(est(i)),
        automaticas: i => est(i) === 'habilitada',
        pausadas: i => est(i) === 'pausada',
    };
    const lista = S.ints.filter(i => F[s.filtro](i) && (!s.q || `${i.nombre} ${i.comando}`.toLowerCase().includes(s.q.toLowerCase())));
    const orden = { revision: 0, corriendo: 1, pendiente: 2, aprobada: 3, pausada: 4, habilitada: 5 };
    lista.sort((a, b) => orden[est(a)] - orden[est(b)]);
    const filtros = [['todas', 'Todas'], ['pendientes', 'Por integrar'], ['revision', 'En revisión'], ['automaticas', 'Automáticas'], ['pausadas', 'Pausadas']]
        .map(([k, t]) => [k, t, cuenta(F[k])]).filter(([k, , n]) => k === 'todas' || n || s.filtro === k);

    return `<div class="bk bk--full qa">
        <aside class="bk-side">
            ${crumb('Centro de QA')}
            <span class="qa-mark" aria-hidden="true">${I.shield}</span>
            <h1 class="bk-title">Centro de <span class="bk-grad">QA</span></h1>
            <p class="bk-subtitle">Corre cada integración en prueba, revisa lo que trae, corrige lo que haga falta e intégrala. Después elige a qué hora corre sola.</p>
            <div class="bk-stats" aria-label="Resumen">
                <div class="bk-stat bk-stat--wait"><div class="bk-stat-n">${cuenta(F.pendientes)}</div><div class="bk-stat-l">por integrar</div></div>
                <div class="bk-stat"><div class="bk-stat-n" style="color:#6d3ce0">${cuenta(F.revision)}</div><div class="bk-stat-l">en revisión</div></div>
                <div class="bk-stat bk-stat--ok"><div class="bk-stat-n">${cuenta(F.automaticas)}</div><div class="bk-stat-l">automáticas</div></div>
            </div>
            ${nav('inicio')}
        </aside>
        <div class="bk-list-main">
            <div class="bk-toolbar">
                <div class="bk-filters" role="group" aria-label="Filtrar por estado">
                    ${filtros.map(([k, t, n]) => `<button type="button" class="bk-filter${s.filtro === k ? ' is-on' : ''}" data-act="filtro-inicio" data-v="${k}" aria-pressed="${s.filtro === k}">${t} · ${n}</button>`).join('')}
                </div>
                <label class="bk-search">${I.search}<span class="bk-sr-only">Buscar integración</span>
                    <input id="qa-q-inicio" type="search" placeholder="Buscar por nombre o comando" value="${esc(s.q)}" data-act="buscar-inicio" autocomplete="off" />
                </label>
            </div>
            <div class="bk-sec-head"><h2 class="bk-sec-title">Integraciones</h2><span class="bk-sec-n">${plural(lista.length, 'integración', 'integraciones')}</span></div>
            ${lista.length ? `<div class="qa-int-grid">${lista.map(tarjetaInt).join('')}</div>` : `<div class="bk-empty"><div class="bk-empty-ico">${I.search}</div><p class="bk-empty-title">Nada con ese filtro</p><p class="bk-empty-text">Prueba con otro estado o borra la búsqueda.</p></div>`}
        </div>
    </div>`;
}

/** Anfitrión de la tarjeta: elegible (con Cambiar) o fijo del servidor. */
function duenoTxt(int) {
    const d = int.dueno;
    const quien = d ? `<span class="qa-dueno-n">${esc(d.nombre || d.correo)}</span><span class="qa-dueno-c">${esc(d.correo)} · #${d.id}</span>` : '<span class="qa-dueno-n">Sin elegir</span>';
    if (!int.elige_dueno) return d ? `${quien}<span class="qa-dueno-c">Definido en el servidor</span>` : 'Varios (definido en el servidor)';
    const puede = !int.en_curso;
    return `${quien}${puede && d ? `<button type="button" class="qa-dueno-btn" data-act="dueno" data-clave="${int.clave}">Cambiar</button>` : ''}`;
}

function tarjetaInt(int) {
    const e = estadoInt(int);
    const u = int.ultima;
    const nota = {
        corriendo: int.en_curso && int.en_curso.tipo === 'prueba' ? 'Corriendo en prueba: todavía no se escribe nada.' : int.en_curso && int.en_curso.estado === 'integrando' ? 'Integrando lo que aprobaste.' : 'Corriendo de verdad.',
        revision: 'Hay una corrida de prueba esperando tu revisión.',
        pendiente: int.con_revision ? 'Nunca se integró: córrela en prueba y revísala antes de que corra sola.' : 'Esta integración no trae fichas para revisar: córrela una vez a mano y, si anda bien, habilítala.',
        aprobada: 'Ya se integró una vez. Elige a qué hora corre y habilítala.',
        habilitada: `Corre sola ${frecuencia(int)} <b>${esc(int.hora)}</b>.`,
        pausada: 'Está pausada: no corre sola hasta que la vuelvas a habilitar.',
    }[e];

    // Sin anfitrión elegido no se puede correr: los alojamientos no tendrían dueño.
    const sinDueno = int.elige_dueno && !int.dueno;
    const acts = [];
    if (sinDueno && !int.en_curso) acts.push(`<button type="button" class="bk-btn bk-btn--primary" data-act="dueno" data-clave="${int.clave}">${I.user} Elegir anfitrión</button>`);
    if (int.en_revision) acts.push(`<a class="bk-btn ${sinDueno ? 'bk-btn--ghost' : 'bk-btn--primary'}" href="/admin/centro-qa/${int.clave}" data-nav="${int.clave}">${I.spark} Seguir revisando</a>`);
    else if (int.en_curso) acts.push(`<button type="button" class="bk-btn bk-btn--primary" data-act="ver-corrida" data-id="${int.en_curso.id}">${I.clock} Ver avance</button>`);
    else if (!sinDueno) {
        if (int.con_revision) acts.push(`<button type="button" class="bk-btn ${e === 'pendiente' ? 'bk-btn--primary' : 'bk-btn--ghost'}" data-act="correr" data-v="prueba" data-clave="${int.clave}">${I.play} Correr en prueba</button>`);
        if (!int.con_revision || e !== 'pendiente') acts.push(`<button type="button" class="bk-btn ${!int.con_revision && e === 'pendiente' ? 'bk-btn--primary' : 'bk-btn--ghost'}" data-act="correr" data-v="manual" data-clave="${int.clave}">${I.refresh} Correr ahora</button>`);
    }
    acts.push(`<a class="bk-btn bk-btn--ghost" href="/admin/centro-qa/${int.clave}/actual" data-nav="${int.clave}/actual">${I.list} Ver integración</a>`);

    const hora = ['aprobada', 'habilitada', 'pausada'].includes(int.estado) && !int.en_curso ? `<div class="qa-hora">
        <span class="qa-hora-t">${int.estado === 'habilitada' ? `Corre sola ${frecuencia(int)} <b>${esc(int.hora)}</b> (hora de Chile).` : int.cada_minutos ? 'Desde qué hora corre (Chile):' : 'Hora a la que corre sola (Chile):'}</span>
        <label class="bk-sr-only" for="qa-hora-${int.clave}">Hora de ${esc(int.nombre)}</label>
        <input type="time" id="qa-hora-${int.clave}" value="${esc(int.hora || '')}" step="300" />
        ${int.estado === 'habilitada'
            ? `<button type="button" class="bk-btn bk-btn--ghost" data-act="guardar-hora" data-clave="${int.clave}">Cambiar hora</button><button type="button" class="bk-btn bk-btn--ghost" data-act="pausar" data-clave="${int.clave}">${I.pause} Pausar</button>`
            : `<button type="button" class="bk-btn bk-btn--primary" data-act="habilitar" data-clave="${int.clave}">${I.check} Habilitar</button>`}
    </div>` : '';

    const run = int.en_curso ? `<div class="qa-int-run">
        <div class="qa-bar" role="progressbar" aria-label="Avance" aria-valuemin="0" aria-valuemax="100" aria-valuenow="${int.en_curso.pct}"><span style="--p:${int.en_curso.pct}%"></span></div>
        <p><span>${esc(int.en_curso.paso || 'Corriendo')}</span><span>${int.en_curso.pct} %</span></p>
    </div>` : '';

    return `<article class="qa-int qa-int--${e}" aria-labelledby="int-${int.clave}">
        <header class="qa-int-head">
            ${logo(int)}
            <div><h3 class="qa-int-name" id="int-${int.clave}">${esc(int.nombre)}</h3><p class="qa-int-src">${esc(int.origen)}</p></div>
            ${BADGE_INT[e] || ''}
        </header>
        <dl class="qa-int-meta">
            <div><dt class="qa-k">Comando</dt><dd class="qa-v"><code>${esc(int.comando)}</code></dd></div>
            <div><dt class="qa-k">Horario</dt><dd class="qa-v">${int.estado === 'habilitada' && int.hora ? (int.cada_minutos ? `${cadaTxt(int.cada_minutos)} · desde ${esc(int.hora)}` : `Todos los días · ${esc(int.hora)}`) : int.hora ? `${esc(int.hora)} (sin habilitar)` : 'Sin horario'}</dd></div>
            <div><dt class="qa-k">Última corrida</dt><dd class="qa-v">${u ? `${fecha(u.terminada || u.creada)} · ${TIPO_TXT[u.tipo] || u.tipo}` : 'Nunca'}</dd></div>
            <div><dt class="qa-k">Resultado</dt><dd class="qa-v">${u ? esc(u.paso || u.estado) : '—'}</dd></div>
            <div class="qa-int-dueno"><dt class="qa-k">Se carga en</dt><dd class="qa-v">${duenoTxt(int)}</dd></div>
        </dl>
        ${run}${hora}
        <footer class="qa-int-foot">
            <p class="qa-int-note">${sinDueno ? 'Elige a qué anfitrión se cargan los alojamientos antes de correrla.' : nota || ''}</p>
            <div class="qa-int-acts">${acts.join('')}</div>
        </footer>
    </article>`;
}

// ── Vista: Revisión de una corrida ─────────────────────────────────────
function itemsFiltrados(c) {
    const s = S.rev, q = s.q.trim().toLowerCase();
    return c.items.filter(i => {
        // El que está abierto en el panel no desaparece de la lista aunque deje de cumplir el filtro.
        if (S.capa && S.capa.tipo === 'item' && S.capa.id === i.id) return true;
        if (s.filtro === 'obs' && !observaciones(i).length) return false;
        if (s.filtro === 'completar' && !paraCompletar(i)) return false;
        if (s.filtro === 'listos' && (observaciones(i).length || !i.incluido)) return false;
        if (s.filtro === 'excluidos' && i.incluido) return false;
        if (s.filtro === 'nuevos' && i.accion !== 'nuevo') return false;
        if (s.filtro === 'publicados' && !i.publicado) return false;
        if (s.filtro === 'ocultos' && i.publicado) return false;
        if (s.hallazgo && !FILTROS_HALLAZGO[s.hallazgo](i)) return false;
        if (q && !`${i.nombre} ${i.idcodigo} ${i.direccion}`.toLowerCase().includes(q)) return false;
        return true;
    });
}

function vRevision() {
    if (S.cargando) return cargandoHtml('Cargando la corrida…');
    if (S.error) return errorHtml();
    const int = intDe(S.clave);
    const c = S.c;
    if (!int || !c) {
        return `<div class="bk qa"><aside class="bk-side"><a class="qa-back" href="/admin/centro-qa" data-nav="">${I.back} Centro de QA</a>${nav('')}</aside>
            <div class="bk-list-main"><div class="bk-empty"><div class="bk-empty-ico">${I.info}</div><p class="bk-empty-title">No hay nada para revisar</p>
            <p class="bk-empty-text">${int ? `${esc(int.nombre)} no tiene una corrida de prueba esperando revisión.` : 'Esa integración no existe.'}</p>
            <a class="bk-btn bk-btn--ghost" href="/admin/centro-qa" data-nav="">Volver al Centro de QA</a></div></div></div>`;
    }
    const R = resumen(c), s = S.rev;
    const precios = preciosPorMoneda(c.items);
    const H = hallazgos(c);
    const lista = itemsFiltrados(c);
    const comp = CAMPOS.map(x => {
        const e = c.items.map(i => estadoCampo(i, x.k).e);
        return { ...x, ok: e.filter(v => v === 'ok').length, warn: e.filter(v => v === 'warn').length, bad: e.filter(v => v === 'bad').length };
    });
    const HALL_DE_CAMPO = { fotos: 'pocas', precio: 'precio', ubicacion: 'ubicacion', amenidades: 'amenidades', camas: 'camas' };
    const V = S.soloVer;
    const publicados = c.items.filter(i => i.publicado).length;
    const filtros = V
        ? [['todos', 'Todos', c.items.length], ['obs', 'Con observaciones', R.conObs], ['completar', 'Para completar', R.completar], ['publicados', 'Publicados', publicados], ['ocultos', 'Ocultos', c.items.length - publicados]]
        : [['todos', 'Todos', c.items.length], ['obs', 'Con observaciones', R.conObs], ['completar', 'Para completar', R.completar], ['nuevos', 'Nuevos', c.items.filter(i => i.accion === 'nuevo').length], ['listos', 'Listos', c.items.filter(i => i.incluido && !observaciones(i).length).length], ['excluidos', 'Excluidos', R.excluidos]];
    const visibles = lista.slice(0, s.max);
    const primera = int.estado === 'pendiente';
    const fotosTot = c.items.reduce((a, i) => a + i.fotos.length, 0);

    if (V && !c.items.length) {
        return `<div class="bk qa"><aside class="bk-side"><a class="qa-back" href="/admin/centro-qa" data-nav="">${I.back} Centro de QA</a>${nav('')}</aside>
            <div class="bk-list-main"><div class="bk-empty"><div class="bk-empty-ico">${I.info}</div><p class="bk-empty-title">${esc(int.nombre)} no tiene alojamientos</p>
            <p class="bk-empty-text">No hay ninguno en la base para esta integración (sin contar los eliminados). Si nunca corrió, córrela primero.</p>
            <a class="bk-btn bk-btn--ghost" href="/admin/centro-qa" data-nav="">Volver al Centro de QA</a></div></div></div>`;
    }

    return `<div class="bk bk--full qa">
        <aside class="bk-side">
            <a class="qa-back" href="/admin/centro-qa" data-nav="">${I.back} Centro de QA</a>
            <span class="qa-mark qa-mark--logo" style="background:${int.color}" aria-hidden="true">${esc(int.corto)}</span>
            ${V ? `<h1 class="bk-title">Integración <span class="bk-grad">${esc(int.nombre)}</span></h1>
            <p class="bk-subtitle">Lo que hay hoy en House &amp; Flats (${fecha(c.creada)}): qué le falta a cada ficha y qué fotos se cargaron. Los textos y las amenidades que corrijas se guardan al instante y quedan fijados: la integración no los vuelve a cambiar.</p>
            <div class="bk-stats" aria-label="Resumen">
                <div class="bk-stat"><div class="bk-stat-n">${num(R.total)}</div><div class="bk-stat-l">alojamientos</div></div>
                <div class="bk-stat bk-stat--ok"><div class="bk-stat-n">${num(publicados)}</div><div class="bk-stat-l">publicados</div></div>
                <div class="bk-stat bk-stat--wait"><div class="bk-stat-n">${num(R.conObs)}</div><div class="bk-stat-l">con observaciones</div></div>
            </div>
            ${R.completar ? `<button type="button" class="qa-side-cta" data-act="filtro-rev" data-v="completar" data-ir="1">${I.text}<span><b>${plural(R.completar, 'ficha incompleta', 'fichas incompletas')}</b>Textos o amenidades que le faltan</span>${I.chevR}</button>` : ''}
            ${int.en_revision ? `<a class="qa-side-cta" href="/admin/centro-qa/${int.clave}" data-nav="${int.clave}">${I.spark}<span><b>Hay una corrida de prueba</b>Esperando revisión</span>${I.chevR}</a>` : ''}
            ${nav('')}
        </aside>` : `<h1 class="bk-title">Revisar <span class="bk-grad">${esc(int.nombre)}</span></h1>
            <p class="bk-subtitle">Corrida de prueba del ${fecha(c.terminada || c.creada)}. Todavía no se guardó nada en House &amp; Flats.</p>
            <ol class="qa-flow" aria-label="Etapas">
                <li class="qa-flow-step is-done"><span class="qa-flow-dot" aria-hidden="true">✓</span><span><span class="qa-flow-t">Correr en prueba</span><span class="qa-flow-d"><code>${esc(int.comando)} --dry-run</code></span></span></li>
                <li class="qa-flow-step is-now" aria-current="step"><span class="qa-flow-dot" aria-hidden="true">2</span><span><span class="qa-flow-t">Revisar</span><span class="qa-flow-d">Revisados ${R.vistos} de ${R.total}. Quita fotos, completa textos y amenidades, y excluye lo que no deba subir.</span></span></li>
                <li class="qa-flow-step"><span class="qa-flow-dot" aria-hidden="true">3</span><span><span class="qa-flow-t">Integrar</span><span class="qa-flow-d">Se corre el sync de verdad, respetando lo que decidiste.</span></span></li>
                <li class="qa-flow-step"><span class="qa-flow-dot" aria-hidden="true">4</span><span><span class="qa-flow-t">Habilitar</span><span class="qa-flow-d">${primera ? 'Eliges la hora y desde ahí corre sola.' : 'Ya está programada: sigue corriendo a su hora.'}</span></span></li>
            </ol>
            <div class="bk-stats" aria-label="Resumen de la revisión">
                <div class="bk-stat"><div class="bk-stat-n">${num(R.total)}</div><div class="bk-stat-l">a revisar</div></div>
                <div class="bk-stat bk-stat--wait"><div class="bk-stat-n">${num(R.conObs)}</div><div class="bk-stat-l">con observaciones</div></div>
                <div class="bk-stat"><div class="bk-stat-n" style="color:#d93a2b">${num(R.excluidos)}</div><div class="bk-stat-l">excluidos</div></div>
            </div>
            ${R.completar ? `<button type="button" class="qa-side-cta" data-act="filtro-rev" data-v="completar" data-ir="1">${I.text}<span><b>${plural(R.completar, 'ficha incompleta', 'fichas incompletas')}</b>Textos o amenidades que puedes completar antes de integrar</span>${I.chevR}</button>` : ''}
            ${nav('')}
        </aside>`}

        <div class="bk-list-main">
            <section class="qa-card" aria-labelledby="r-sum">
                <div class="qa-card-head">
                    <h2 class="qa-card-title" id="r-sum">${V ? 'Resumen de la integración' : 'Resumen de la corrida'}</h2>
                    <p class="qa-card-meta"><code>${esc(int.comando)}${V ? '' : ' --dry-run'}</code> · ${fecha(c.terminada || c.creada)}</p>
                </div>
                <div class="qa-kpis">${V ? `
                    <div class="qa-kpi"><b>${num(R.total)}</b><span>alojamientos</span></div>
                    <div class="qa-kpi qa-kpi--ok"><b>${num(publicados)}</b><span>publicados</span></div>
                    <div class="qa-kpi qa-kpi--off"><b>${num(R.total - publicados)}</b><span>ocultos</span></div>
                    <div class="qa-kpi qa-kpi--new"><b>${num(R.conObs)}</b><span>con observaciones</span></div>
                    <div class="qa-kpi"><b>${num(fotosTot)}</b><span>fotos cargadas</span></div>` : `
                    <div class="qa-kpi"><b>${num((c.resumen && c.resumen.leidos) || R.total)}</b><span>leídos del feed</span></div>
                    <div class="qa-kpi qa-kpi--new"><b>${num(R.nuevos)}</b><span>nuevos</span></div>
                    <div class="qa-kpi"><b>${num(R.actualiza)}</b><span>se actualizan</span></div>
                    <div class="qa-kpi qa-kpi--ok"><b>${num(R.publican)}</b><span>quedarían publicados</span></div>
                    <div class="qa-kpi qa-kpi--off"><b>${num(R.ocultos)}</b><span>quedarían ocultos</span></div>`}
                </div>
                <div class="qa-sum-grid">
                    <div>
                        <p class="qa-sub">Precio medio por moneda</p>
                        <div class="qa-money">${precios.map(p => {
                            const ancho = p.max - p.min || 1;
                            const puntos = c.items.filter(i => i.moneda === p.cur && i.precio).slice(0, 400).map(i => {
                                const raro = i.precio / p.media >= 2 || i.precio / p.media <= 0.5;
                                return `<i class="${raro ? 'is-bad' : ''}" style="left:${((i.precio - p.min) / ancho) * 100}%"></i>`;
                            }).join('');
                            return `<div class="qa-money-row">
                                <span class="qa-cur${p.ok ? '' : ' qa-cur--bad'}">${p.cur}</span>
                                <span class="qa-money-avg">${dinero(p.media, p.cur)} <small>/ mes</small></span>
                                <span class="qa-money-d${p.ok ? '' : ' is-bad'}">${p.ok ? `${plural(p.n, 'alojamiento', 'alojamientos')} · de ${dinero(p.min, p.cur)} a ${dinero(p.max, p.cur)}` : `${plural(p.n, 'alojamiento', 'alojamientos')} · sin tipo de cambio en HyF: entran ocultos`}</span>
                                <span class="qa-range" aria-hidden="true">${puntos}<em style="left:${((p.media - p.min) / ancho) * 100}%"></em></span>
                            </div>`;
                        }).join('') || '<p class="qa-text is-empty">Ningún alojamiento trae precio.</p>'}</div>
                    </div>
                    <div>
                        <p class="qa-sub">Cómo vienen los datos</p>
                        <div class="qa-comp">${comp.map(x => `<button type="button" class="qa-comp-row" data-act="hallazgo" data-v="${HALL_DE_CAMPO[x.k] || 'textos'}" title="Ver los que hay que revisar">
                            <span class="qa-comp-l">${x.t}</span>
                            <span class="qa-comp-bar" aria-hidden="true"><span class="is-ok" style="width:${x.ok / (R.total || 1) * 100}%"></span><span class="is-warn" style="width:${x.warn / (R.total || 1) * 100}%"></span><span class="is-bad" style="width:${x.bad / (R.total || 1) * 100}%"></span></span>
                            <span class="qa-comp-n">${x.ok}/${R.total}<span class="bk-sr-only"> bien, ${x.warn} a revisar, ${x.bad} a corregir</span></span>
                        </button>`).join('')}</div>
                        <p class="qa-legend"><span style="--c:#1f9d6c">Bien</span><span style="--c:#e9a23b">Revisar</span><span style="--c:#d93a2b">Corregir</span></p>
                    </div>
                </div>
            </section>

            <section class="qa-card" aria-labelledby="r-hall">
                <div class="qa-finds-head">
                    <span class="qa-kiro-av" aria-hidden="true">${I.spark}</span>
                    <div><h2 class="qa-card-title" id="r-hall">${V ? 'Lo que le falta a esta integración' : 'Lo que encontró la revisión automática'}</h2><p class="qa-card-meta">Revisó ${plural(R.total, 'alojamiento', 'alojamientos')}: fotos, precios, ubicación, amenidades y textos. Toca un hallazgo para ver esos alojamientos.</p></div>
                </div>
                <div class="qa-finds">${H.map(h => `<button type="button" class="qa-find qa-find--${h.e}${s.hallazgo && s.hallazgo === h.f ? ' is-on' : ''}" data-act="hallazgo" data-v="${h.f || ''}"${h.f ? ` aria-pressed="${s.hallazgo === h.f}"` : ' disabled'}>
                    <span class="qa-find-ico" aria-hidden="true">${h.ico}</span><span><span class="qa-find-t">${h.t}</span><span class="qa-find-d">${h.d}</span></span>
                </button>`).join('')}</div>
            </section>

            <div class="bk-toolbar" id="qa-lista">
                <div class="bk-filters" role="group" aria-label="Filtrar alojamientos">
                    ${filtros.map(([k, t, n]) => `<button type="button" class="bk-filter${s.filtro === k ? ' is-on' : ''}" data-act="filtro-rev" data-v="${k}" aria-pressed="${s.filtro === k}">${t} · ${num(n)}</button>`).join('')}
                    ${s.hallazgo ? `<button type="button" class="bk-filter is-on" data-act="hallazgo" data-v="" aria-label="Quitar filtro ${NOMBRE_HALLAZGO[s.hallazgo]}">${NOMBRE_HALLAZGO[s.hallazgo]} ×</button>` : ''}
                </div>
                <label class="bk-search">${I.search}<span class="bk-sr-only">Buscar alojamiento</span>
                    <input id="qa-q-rev" type="search" placeholder="Nombre, código o dirección" value="${esc(s.q)}" data-act="buscar-rev" autocomplete="off" />
                </label>
            </div>

            <div class="bk-sec-head"><h2 class="bk-sec-title">${V ? 'Alojamientos de la integración' : 'Alojamientos de la corrida'}</h2><span class="bk-sec-n">${lista.length === c.items.length ? plural(lista.length, 'alojamiento', 'alojamientos') : `${num(lista.length)} de ${num(c.items.length)}`}</span></div>
            ${lista.length ? `<div class="qa-list">${visibles.map(fila).join('')}</div>
                ${lista.length > visibles.length ? `<div class="qa-mas"><button type="button" class="bk-btn bk-btn--ghost" data-act="ver-mas">Ver ${num(Math.min(60, lista.length - visibles.length))} más (quedan ${num(lista.length - visibles.length)})</button></div>` : ''}`
                : `<div class="bk-empty"><div class="bk-empty-ico">${I.check}</div><p class="bk-empty-title">Nada por acá</p><p class="bk-empty-text">Ningún alojamiento cumple ese filtro.</p><button type="button" class="bk-btn bk-btn--ghost" data-act="limpiar-rev">Ver todos</button></div>`}
            ${!V && c.resumen && c.resumen.leidos > c.items.length ? `<p class="qa-quiet">${I.info}<span>Otros <b>${num(c.resumen.leidos - c.items.length)}</b> del feed no se listan (excluidos antes en el Centro de QA, o con error al leerlos).</span></p>` : ''}

            ${V ? '' : `<div class="bk-bar" id="qa-barra">${barraHtml(R)}</div>`}
        </div>
    </div>`;
}

function barraHtml(R) {
    const hayAlgo = R.pendientes || R.excluidos || R.quitadas || R.textos || R.amen || R.cant;
    const guardando = pendientes.size || enVuelo;
    return `<div class="qa-bar-sum" aria-live="polite">
            <span><b>${num(R.incluidos)}</b> se integran</span>
            ${R.excluidos ? `<span><b>${num(R.excluidos)}</b> excluidos</span>` : ''}
            ${R.quitadas ? `<span><b>${num(R.quitadas)}</b> fotos quitadas</span>` : ''}
            ${R.textos ? `<span><b>${num(R.textos)}</b> ${R.textos === 1 ? 'texto corregido' : 'textos corregidos'}</span>` : ''}
            ${R.amen ? `<span><b>${num(R.amen)}</b> ${R.amen === 1 ? 'amenidad cambiada' : 'amenidades cambiadas'}</span>` : ''}
            ${R.cant ? `<span><b>${num(R.cant)}</b> ${R.cant === 1 ? 'cantidad cambiada' : 'cantidades cambiadas'} (camas, baños…)</span>` : ''}
            ${R.pendientes ? `<span class="is-bad"><b>${num(R.pendientes)}</b> fotos marcadas sin decidir</span>` : ''}
            ${!hayAlgo ? '<span>Sin cambios tuyos todavía</span>' : ''}
            <span class="qa-guardando">${guardando ? 'Guardando…' : 'Todo guardado'}</span>
        </div>
        <div class="bk-bar-actions">
            <button type="button" class="bk-btn bk-btn--ghost" data-act="descartar">Descartar corrida</button>
            <button type="button" class="bk-btn bk-btn--primary" data-act="integrar"${R.incluidos ? '' : ' disabled'}>${I.upload} Integrar ${plural(R.incluidos, 'alojamiento', 'alojamientos')}</button>
        </div>`;
}
/** Solo la barra de abajo (el "Guardando…"), sin repintar toda la lista. */
function pintarBarra() {
    const b = $('#qa-barra');
    if (b && S.c) b.innerHTML = barraHtml(resumen(S.c));
}

function chips(it) {
    const obs = observaciones(it);
    if (!obs.length) return '<span class="qa-chk"><i aria-hidden="true">✓</i>Todo en orden</span>';
    return obs.map(o => `<span class="qa-chk is-${o.e}"><i aria-hidden="true">${MARCA_E[o.e]}</i>${o.t}${o.corto ? ` · ${esc(o.corto)}` : ''}</span>`).join('');
}
function medidor(it) {
    const est = estados(it), ok = est.filter(x => x.e === 'ok').length;
    return `<span class="qa-meter" title="${ok} de ${est.length} campos bien"><span class="qa-meter-bar" aria-hidden="true">${est.map(x => `<i class="is-${x.e}"></i>`).join('')}</span><span class="qa-meter-n">${ok}/${est.length}<span class="bk-sr-only"> campos bien</span></span></span>`;
}
function fila(it) {
    const portada = fotosActivas(it)[0];
    const mal = fotosMarcadas(it).length;
    const pr = estadoCampo(it, 'precio');
    const pub = publicable(it);
    const abierto = S.capa && S.capa.tipo === 'item' && S.capa.id === it.id;
    return `<article class="qa-row${it.incluido ? '' : ' is-out'}${abierto ? ' is-open' : ''}">
        <div class="qa-row-img">${portada ? imagen(portada) : ''}${mal ? `<span class="qa-pill-bad">${I.img}${mal}</span>` : ''}</div>
        <div class="qa-row-main">
            <div class="qa-row-top">${S.soloVer ? `
                <span class="bk-badge ${it.publicado ? 'bk-badge--ok' : 'bk-badge--plain'}">${it.publicado ? 'Publicado' : 'Oculto'}</span>
                ${it.publicado && !pub.ok ? `<span class="bk-badge bk-badge--plain">Se vería mal · ${esc(pub.motivo)}</span>` : ''}
                ${it.fijados.size ? `<span class="bk-badge bk-badge--rev">Corregido a mano · ${it.fijados.size}</span>` : ''}` : `
                <span class="bk-badge ${it.accion === 'nuevo' ? 'bk-badge--pay' : ''}">${it.accion === 'nuevo' ? 'Nuevo' : 'Se actualiza'}</span>
                ${pub.ok ? '' : `<span class="bk-badge bk-badge--plain">Entraría oculto · ${esc(pub.motivo)}</span>`}
                ${it.visto ? '<span class="bk-badge bk-badge--plain bk-badge--ok">Revisado</span>' : ''}
                ${editado(it) ? '<span class="bk-badge bk-badge--rev">Corregido en QA</span>' : ''}`}
                ${medidor(it)}
            </div>
            <button type="button" class="qa-row-name qa-row-open" data-act="abrir" data-id="${it.id}" id="qa-abrir-${it.id}">${esc(it.nombre)}</button>
            <p class="qa-row-sub"><code>${esc(it.idcodigo)}</code> · ${esc(it.direccion)} · ${plural(fotosActivas(it).length, 'foto', 'fotos')}</p>
            <div class="qa-chks">${chips(it)}</div>
        </div>
        <div class="qa-row-price">
            <b>${it.precio ? dinero(it.precio, it.moneda) : '—'}</b>
            <span class="${pr.e === 'ok' ? '' : 'is-bad'}">${pr.e === 'ok' ? `${it.moneda} · ${esc(it.modalidad.toLowerCase())}` : esc(pr.corto)}</span>
        </div>
        <div class="qa-row-end">
            ${S.soloVer ? '' : `<label class="qa-switch" title="Incluir en la integración">
                <input type="checkbox" data-act="incluir" data-id="${it.id}" id="qa-inc-${it.id}"${it.incluido ? ' checked' : ''} />
                <span class="qa-switch-ui" aria-hidden="true"></span><span>${it.incluido ? 'Incluido' : 'Excluido'}</span>
            </label>`}
            <span class="qa-row-go" aria-hidden="true">${I.chevR}</span>
        </div>
    </article>`;
}

// ── Vista: Historial ───────────────────────────────────────────────────
const ESTADO_HIST = {
    integrada: '<span class="bk-badge bk-badge--ok">Integrada</span>', ok: '<span class="bk-badge bk-badge--ok">Bien</span>',
    descartada: '<span class="bk-badge">Descartada</span>', fallida: '<span class="bk-badge bk-badge--bad">Falló</span>',
    revision: '<span class="bk-badge bk-badge--rev">En revisión</span>', integrando: '<span class="bk-badge bk-badge--wait">Integrando</span>',
};
function resultadoHist(c) {
    const r = c.resumen || {};
    if (r.decisiones) {
        const d = r.decisiones;
        return [d.excluidos ? plural(d.excluidos, 'excluido', 'excluidos') : '', d.fotos ? plural(d.fotos, 'foto quitada', 'fotos quitadas') : '', d.textos ? plural(d.textos, 'texto', 'textos') : '', d.amenidades ? plural(d.amenidades, 'amenidad', 'amenidades') : ''].filter(Boolean).join(' · ') || 'Sin correcciones';
    }
    if (r.total != null) return `${plural(r.total, 'alojamiento', 'alojamientos')} · ${num(r.con_hallazgos || 0)} con algo para mirar`;
    if (r.segundos != null) return `Tardó ${num(r.segundos)} s`;
    return esc(c.paso || '—');
}
function vHistorial() {
    return `<div class="bk qa">
        <aside class="bk-side">
            ${crumb('Centro de QA')}
            <span class="qa-mark" aria-hidden="true">${I.clock}</span>
            <h1 class="bk-title">Historial de <span class="bk-grad">QA</span></h1>
            <p class="bk-subtitle">Cada corrida: las de prueba, las que se integraron y las que corrieron solas a su hora.</p>
            ${nav('historial')}
        </aside>
        <div class="bk-list-main">
            ${!S.hist ? (S.error ? errorHtml() : cargandoHtml('Cargando el historial…')) : `<section class="qa-card" aria-labelledby="h-t">
                <div class="qa-card-head"><h2 class="qa-card-title" id="h-t">Últimas corridas</h2><p class="qa-card-meta">${plural(S.hist.length, 'corrida', 'corridas')}</p></div>
                ${S.hist.length ? `<div class="qa-hist">${S.hist.map(c => {
                    const int = intDe(c.integracion) || { nombre: c.integracion, corto: '?', color: '#8a7f76' };
                    return `<div class="qa-hist-row">
                        ${logo(int)}
                        <div><p class="qa-hist-t">${esc(int.nombre)}</p><p class="qa-hist-d">${fecha(c.terminada || c.creada)} · ${esc(c.quien)}</p></div>
                        <div><span class="qa-k">Tipo</span><span class="qa-v">${TIPO_TXT[c.tipo] || esc(c.tipo)}</span></div>
                        <div><span class="qa-k">Resultado</span><span class="qa-v">${resultadoHist(c)}</span></div>
                        <div style="display:flex;gap:8px;align-items:center">${ESTADO_HIST[c.estado] || ''}<button type="button" class="bk-btn bk-btn--ghost" data-act="ver-corrida" data-id="${c.id}">Ver log</button></div>
                    </div>`;
                }).join('')}</div>` : '<p class="qa-text is-empty">Todavía no corrió nada desde el Centro de QA.</p>'}
            </section>`}
        </div>
    </div>`;
}
const errorHtml = () => `<div class="bk-empty"><div class="bk-empty-ico">${I.alert}</div><p class="bk-empty-title">No se pudo cargar</p><p class="bk-empty-text">${esc(S.error)}</p><button type="button" class="bk-btn bk-btn--ghost" data-act="reintentar">Reintentar</button></div>`;

// ── Panel del alojamiento ──────────────────────────────────────────────
function seccion(titulo, est, cuerpo, extra = '', k = '') {
    return `<section class="qa-sec qa-sec--${est.e}"${k ? ` id="qa-sec-${k}"` : ''} aria-label="${esc(titulo)}">
        <header class="qa-sec-head"><h3 class="qa-sec-title">${esc(titulo)}</h3><span class="bk-badge ${BADGE_E[est.e]}">${TXT_E[est.e]}${est.corto ? ` · ${esc(est.corto)}` : ''}</span>${extra ? `<span class="qa-sec-acts">${extra}</span>` : ''}</header>
        ${cuerpo}
        ${est.nota ? `<p class="qa-note"><span class="qa-note-av" aria-hidden="true">${I.spark}</span><span>${est.nota}</span></p>` : ''}
    </section>`;
}
function seccionTexto(it, k, est) {
    const t = it.textos[k], T = TEXTOS[k];
    if (S.capa.editando === k) {
        const v = S.capa.borrador;
        const sug = t.vOrig === 'contacto' ? sinContacto(t.original) : '';
        const cuerpo = `<div class="qa-edit">
            <label class="bk-sr-only" for="qa-ed-txt">Texto de ${esc(T)}</label>
            <textarea id="qa-ed-txt" class="qa-edit-txt" data-act="borrador" rows="5" placeholder="Escribe ${esc(T.toLowerCase())} como se va a ver en la ficha">${esc(v)}</textarea>
            <div class="qa-edit-foot"><span class="qa-edit-hint" id="qa-ed-hint" aria-live="polite">${pista(v)}</span><span class="qa-edit-n" id="qa-ed-n">${num(v.trim().length)} caracteres</span></div>
            ${sug && sug !== v.trim() ? `<div class="qa-aplicar"><span class="qa-aplicar-ico" aria-hidden="true">${I.phone}</span><div class="qa-aplicar-main">
                <p class="qa-aplicar-t">El mismo texto del feed, sin el teléfono ni el correo</p><p class="qa-text">${esc(sug)}</p>
                <div class="qa-aplicar-acts"><button type="button" class="bk-btn bk-btn--ghost" data-act="usar-sug" id="qa-ed-sug">Usar este</button></div></div></div>` : ''}
            <div class="qa-edit-acts">
                <span class="qa-edit-kbd"><kbd>Ctrl</kbd> + <kbd>Enter</kbd> guarda · <kbd>Esc</kbd> cancela</span>
                <button type="button" class="bk-btn bk-btn--ghost" data-act="cancelar-ed" id="qa-ed-no">Cancelar</button>
                <button type="button" class="bk-btn bk-btn--primary" data-act="guardar-ed" id="qa-ed-si">${I.check} Guardar texto</button>
            </div>
        </div>`;
        return seccion(T, est, cuerpo, '', k);
    }
    let cuerpo = (t.valor
        ? `<p class="qa-text">${t.v === 'contacto' ? marcar(t.valor) : esc(t.valor)}</p>`
        : `<button type="button" class="qa-empty-cta" data-act="editar" data-v="${k}" id="qa-ed-vacio-${k}">${I.text}<span><b>Escribir ${esc(T.toLowerCase())}</b>${t.editado ? 'Lo dejaste vacío.' : S.soloVer ? 'La ficha no tiene este texto.' : 'El feed no trae este texto.'}</span></button>`)
        + (t.editado ? `<details class="qa-orig"><summary>${S.soloVer ? 'Ver lo que tenía antes' : 'Ver lo que traía el feed'}</summary>${t.original ? `<p class="qa-text">${esc(t.original)}</p>` : '<p class="qa-text is-empty">Estaba vacío.</p>'}</details>` : '');
    cuerpo += bloqueAplicar(it, k);
    const botones = [
        t.v === 'contacto' ? `<button type="button" class="bk-btn bk-btn--ghost" data-act="quitar-contacto" data-v="${k}" id="qa-ed-cto-${k}">${I.phone} Quitar contacto</button>` : '',
        // En vivo no hay "volver al del feed": el texto anterior ya se pisó en la base.
        t.editado && !S.soloVer ? `<button type="button" class="bk-btn bk-btn--ghost" data-act="restaurar-txt" data-v="${k}" id="qa-ed-rst-${k}">${I.refresh} Volver al del feed</button>` : '',
        t.valor ? `<button type="button" class="bk-btn ${est.e === 'ok' ? 'bk-btn--ghost' : 'bk-btn--primary'}" data-act="editar" data-v="${k}" id="qa-ed-btn-${k}">${I.text} ${est.e === 'ok' ? 'Editar' : 'Corregir'}</button>` : '',
    ].join('');
    return seccion(T, est, cuerpo, botones, k);
}
// ── Aplicar a otros alojamientos ──
// Candidatos: todos los demás (incluidos) que no tienen ya lo mismo. Marcados
// de entrada: a los que les falta. Se usa igual para textos y amenidades.
function candidatosTexto(it, k) {
    const valor = it.textos[k].valor.trim();
    const otros = S.c.items.filter(i => i.id !== it.id && i.incluido && i.textos[k].valor.trim() !== valor);
    return { otros, faltan: otros.filter(i => ['vacio', 'corto'].includes(i.textos[k].v)) };
}
function candidatosAmen(it) {
    const { agregadas, quitadas } = cambiosAmen(it);
    const otros = S.c.items.filter(i => i.id !== it.id && i.incluido && i.amenLista.length
        && (agregadas.some(c => !i.columnas.includes(c)) || quitadas.some(c => i.columnas.includes(c))));
    return { otros, faltan: otros.filter(i => agregadas.some(c => !i.columnas.includes(c))) };
}
const AVISO_VIVO = 'Se escribe ya en House &amp; Flats y queda fijado: las corridas automáticas no lo cambian, aunque el feed traiga otra cosa o venga vacío.';
function cajaAplicar(k, { otros, faltan }, titulo, desc, warn, detalle) {
    const cap = S.capa;
    if (!otros.length || (cap.noAplicar || []).includes(k)) return '';
    cap.sel = cap.sel || {};
    if (!cap.sel[k]) cap.sel[k] = faltan.map(i => i.id);
    const sel = cap.sel[k];
    const abierto = cap.eligiendo === k;
    const nSel = otros.filter(i => sel.includes(i.id)).length;
    const lista = abierto ? `<div class="qa-aplicar-list" role="group" aria-label="Alojamientos a los que se aplica">${otros.map(i => `<label class="qa-aplicar-it">
            <input type="checkbox" data-act="aplicar-sel" data-k="${k}" data-id="${i.id}" id="qa-ap-${k}-${i.id}"${sel.includes(i.id) ? ' checked' : ''} />
            <span><b>${esc(i.nombre)}</b><small>${detalle(i)}</small></span>
        </label>`).join('')}</div>` : '';
    const botones = abierto
        ? `<button type="button" class="bk-btn bk-btn--primary" data-act="aplicar" data-v="${k}" data-modo="sel" id="qa-ap-si-${k}"${nSel ? '' : ' disabled'}>${I.copy} Aplicar a ${plural(nSel, 'alojamiento', 'alojamientos')}</button>`
        : `${faltan.length ? `<button type="button" class="bk-btn bk-btn--primary" data-act="aplicar" data-v="${k}" data-modo="faltan" id="qa-ap-si-${k}">${I.copy} Aplicar a los ${num(faltan.length)} que les falta</button>` : ''}
           <button type="button" class="bk-btn ${faltan.length ? 'bk-btn--ghost' : 'bk-btn--primary'}" data-act="aplicar" data-v="${k}" data-modo="todos" id="qa-ap-todos-${k}">${faltan.length ? '' : I.copy + ' '}Aplicar a todos (${num(otros.length)})</button>`;
    return `<div class="qa-aplicar">
        <span class="qa-aplicar-ico" aria-hidden="true">${I.copy}</span>
        <div class="qa-aplicar-main">
            <p class="qa-aplicar-t">${titulo}</p>
            <p class="qa-aplicar-d">${desc}</p>
            ${warn || ''}
            ${lista}
            <div class="qa-aplicar-acts">
                ${botones}
                <button type="button" class="bk-btn bk-btn--ghost" data-act="elegir-aplicar" data-v="${k}" id="qa-ap-elegir-${k}" aria-expanded="${abierto}">${abierto ? 'Ocultar la lista' : 'Elegir cuáles'}</button>
                <button type="button" class="bk-btn bk-btn--ghost" data-act="no-aplicar" data-v="${k}" id="qa-ap-no-${k}">${I.check} Solo a este</button>
            </div>
        </div>
    </div>`;
}
/** Con un texto corregido: ofrece usarlo en los demás alojamientos (a los que les falta, o a todos). */
function bloqueAplicar(it, k) {
    const t = it.textos[k];
    const corregido = t.editado || (S.soloVer && it.fijados.has(k));
    if (!corregido || t.v !== 'ok') return '';
    const cand = candidatosTexto(it, k), T = TEXTOS[k].toLowerCase();
    const barrio = (it.direccion.split(',').pop() || '').trim();
    const otroBarrio = barrio && t.valor.includes(barrio) ? cand.otros.filter(i => !i.direccion.includes(barrio)).length : 0;
    return cajaAplicar(k, cand,
        cand.faltan.length ? `A <b>${plural(cand.faltan.length, 'alojamiento más', 'alojamientos más')}</b> les falta ${esc(T)}` : `Usar este texto de ${esc(T)} en otros alojamientos`,
        S.soloVer ? AVISO_VIVO : 'Puedes usar este mismo texto en ellos. Queda marcado como copiado para que lo revises.',
        otroBarrio ? `<p class="qa-aplicar-warn">${I.alert}<span>El texto menciona <b>${esc(barrio)}</b> y ${otroBarrio} de ellos están en otro lugar. Elige cuáles o ajusta el texto.</span></p>` : '',
        i => `${esc(i.direccion)} · ${i.textos[k].v === 'vacio' ? 'Vacío' : `Dice "${esc(i.textos[k].valor.slice(0, 70))}${i.textos[k].valor.length > 70 ? '…' : ''}"`}`);
}
/** Con amenidades cambiadas: ofrece hacer el mismo cambio en otros alojamientos. */
function bloqueAplicarAmen(it) {
    const { agregadas, quitadas } = cambiosAmen(it);
    if (!agregadas.length && !quitadas.length) return '';
    const cambio = [...agregadas.map(c => '+ ' + etiquetaAmen(it, c)), ...quitadas.map(c => '− ' + etiquetaAmen(it, c))].join(', ');
    return cajaAplicar('__amen', candidatosAmen(it),
        `Hacer el mismo cambio (<b>${esc(cambio)}</b>) en otros alojamientos`,
        S.soloVer ? AVISO_VIVO : 'Se aplica al integrar, igual que en este.',
        '', i => `${esc(i.direccion)} · ${plural(i.columnas.length, 'amenidad', 'amenidades')}`);
}
/** Con camas, baños o capacidad cambiados: ofrece poner lo mismo en otros alojamientos. */
function candidatosCant(it) {
    const cols = cambiosCant(it);
    const otros = S.c.items.filter(i => i.id !== it.id && i.incluido && i.cantLista.length && cols.some(c => i.cant[c] !== it.cant[c]));
    // Marcados de entrada: los que tienen en 0 algo de lo que cambiaste.
    return { otros, faltan: otros.filter(i => cols.some(c => !i.cant[c] && it.cant[c])) };
}
function bloqueAplicarCant(it) {
    const cols = cambiosCant(it);
    if (!cols.length) return '';
    const cambio = cols.map(c => `${etiquetaCant(it, c)}: ${it.cant[c]}`).join(', ');
    return cajaAplicar('__cant', candidatosCant(it),
        `Poner lo mismo (<b>${esc(cambio)}</b>) en otros alojamientos`,
        S.soloVer ? AVISO_VIVO : 'Se aplica al integrar, igual que en este.',
        '', i => `${esc(i.direccion)} · ${cols.map(c => `${esc(etiquetaCant(i, c))}: ${i.cant[c] || 0}`).join(', ')}`);
}
function bloqueCant(it) {
    const grupos = [];
    it.cantLista.forEach(c => {
        let x = grupos.find(y => y.g === c.g);
        if (!x) grupos.push(x = { g: c.g, items: [] });
        x.items.push(c);
    });
    const fila = c => {
        const n = it.cantLista.indexOf(c), v = it.cant[c.col] || 0, antes = it.cantOrig[c.col] || 0;
        const marca = v !== antes ? `<small>antes ${num(antes)}</small>` : S.soloVer && it.fijados.has(c.col) ? '<small>fijada</small>' : '';
        const tuya = v !== antes || (S.soloVer && it.fijados.has(c.col));
        return `<div class="qa-cant${v ? ' is-on' : ''}${tuya ? ' is-tuya' : ''}">
            <label class="qa-cant-t" for="qa-ct-${n}">${esc(c.t)}${marca}</label>
            <div class="qa-cant-ctl">
                <button type="button" class="qa-cant-b" data-act="cant" data-v="${esc(c.col)}" data-d="-1" aria-label="Uno menos de ${esc(c.t)}"${v <= 0 ? ' disabled' : ''}>−</button>
                <input type="number" id="qa-ct-${n}" class="qa-cant-in" data-act="cant-in" data-v="${esc(c.col)}" min="0" max="${c.max}" step="1" value="${v}" inputmode="numeric" />
                <button type="button" class="qa-cant-b" data-act="cant" data-v="${esc(c.col)}" data-d="1" aria-label="Uno más de ${esc(c.t)}"${v >= c.max ? ' disabled' : ''}>+</button>
            </div>
        </div>`;
    };
    return `${grupos.map(x => `<div class="qa-amen-g"><p class="qa-amen-gt">${esc(x.g)}</p><div class="qa-cants">${x.items.map(fila).join('')}</div></div>`).join('')}
    <p class="qa-amen-help">${S.soloVer ? 'Cambia una cantidad: se guarda al instante y queda fijada, aunque la integración corra sola.' : 'Cambia una cantidad: queda fija al integrar, aunque el feed traiga otra cosa.'}</p>
    ${bloqueAplicarCant(it)}`;
}
function bloqueAmen(it) {
    if (!it.amenLista.length) return '<p class="qa-text is-empty">Esta integración no trae amenidades.</p>';
    const boton = a => {
        const n = it.amenLista.indexOf(a);
        const on = it.columnas.includes(a.col), antes = it.amenOrig.includes(a.col);
        const tuya = on !== antes || (S.soloVer && it.fijados.has(a.col));
        const marca = on && !antes ? '<small>agregada</small>' : !on && antes ? '<small>quitada</small>' : S.soloVer && it.fijados.has(a.col) ? '<small>fijada</small>' : '';
        return `<button type="button" class="qa-amen-b${on ? ' is-on' : ''}${tuya ? ' is-tuya' : ''}" data-act="amen" data-v="${esc(a.col)}" id="qa-am-${n}" aria-pressed="${on}"><i aria-hidden="true">${on ? '✓' : '+'}</i>${esc(a.t)}${marca}</button>`;
    };
    // En grupos, como el formulario del alojamiento (Edificio, Cocina, …, Cercano a).
    const grupos = [];
    it.amenLista.forEach(a => {
        const g = a.g || 'Amenidades';
        let x = grupos.find(y => y.g === g);
        if (!x) grupos.push(x = { g, items: [] });
        x.items.push(a);
    });
    return `${grupos.map(x => {
        const n = x.items.filter(a => it.columnas.includes(a.col)).length;
        return `<div class="qa-amen-g"><p class="qa-amen-gt">${esc(x.g)} <span>${n} de ${x.items.length}</span></p>
            <div class="qa-amen" role="group" aria-label="${esc(x.g)}">${x.items.map(boton).join('')}</div></div>`;
    }).join('')}
    ${it.sinColumna.length ? `<div class="qa-amen-g"><p class="qa-amen-gt">Del feed, sin columna en HyF</p><div class="qa-amen">${it.sinColumna.map(a => `<span class="qa-amen-x">${esc(a)}</span>`).join('')}</div></div>` : ''}
    <p class="qa-amen-help">${S.soloVer ? 'Toca una amenidad para agregarla o quitarla: se guarda al instante y queda fijada, aunque la integración corra sola.' : 'Toca una amenidad para agregarla o quitarla. Lo que cambies queda fijo al integrar, aunque el feed traiga otra cosa.'}</p>
    ${bloqueAplicarAmen(it)}`;
}

function vItem(id) {
    const c = S.c;
    const lista = itemsFiltrados(c);
    const it = c.items.find(i => i.id === id);
    if (!it) return '';
    const pos = lista.findIndex(i => i.id === id);
    const ant = lista[pos - 1], sig = lista[pos + 1];
    const act = fotosActivas(it);
    const portadaId = act[0] && act[0].id;
    const mal = fotosMarcadas(it);
    const ref = preciosPorMoneda(c.items).find(p => p.cur === it.moneda);
    const pub = publicable(it);
    const e = k => estadoCampo(it, k);

    const fotos = it.fotos.length ? `<div class="qa-photos">${it.fotos.map((f, n) => {
        const marcada = f.defecto && !f.aceptada;
        const why = marcada && !f.quitada ? `<span class="qa-ph-why"><b>${esc(DEFECTOS[f.defecto] || f.defecto)}</b>${f.defecto === 'repetida' && f.igualA ? `Es la misma que la foto ${f.igualA}.` : esc(f.detalle)}</span>` : '';
        let botones;
        if (f.quitada) botones = `<button type="button" class="qa-ph-btn" data-act="foto" data-op="restaurar" data-f="${f.id}" id="qa-f-${f.id}">Restaurar</button>`;
        else if (marcada) botones = `<button type="button" class="qa-ph-btn qa-ph-btn--bad" data-act="foto" data-op="quitar" data-f="${f.id}" id="qa-f-${f.id}">Quitar</button><button type="button" class="qa-ph-btn" data-act="foto" data-op="ok" data-f="${f.id}" id="qa-fo-${f.id}">Está bien</button>`;
        else botones = `<button type="button" class="qa-ph-btn" data-act="foto" data-op="quitar" data-f="${f.id}" id="qa-f-${f.id}">Quitar</button>`;
        return `<figure class="qa-ph${marcada && !f.quitada ? ' is-bad' : ''}${f.quitada ? ' is-off' : ''}">
            <a href="${esc(urlFoto(f.src))}" target="_blank" rel="noopener noreferrer" aria-label="Abrir la foto ${n + 1} en grande">${imagen(f)}</a>
            <span class="qa-ph-n">${n + 1}</span>
            ${f.id === portadaId ? '<span class="qa-ph-cover">Portada</span>' : ''}
            ${f.quitada ? '<span class="qa-ph-off">No se sube</span>' : ''}
            <figcaption class="qa-ph-cap">${why}<span class="qa-ph-acts">${botones}</span></figcaption>
        </figure>`;
    }).join('')}</div>` : '<p class="qa-text is-empty">El feed no trae fotos.</p>';

    const hechos = `<div class="qa-facts">
        <div class="qa-fact${e('precio').e === 'ok' ? '' : ' is-bad'}"><span class="qa-k">Precio</span><span class="qa-v">${it.precio ? dinero(it.precio, it.moneda) : '0'} / mes</span></div>
        <div class="qa-fact${MONEDAS_OK.includes(it.moneda) ? '' : ' is-bad'}"><span class="qa-k">Moneda</span><span class="qa-v">${esc(it.moneda)}</span></div>
        <div class="qa-fact"><span class="qa-k">Media de la corrida</span><span class="qa-v">${ref ? dinero(ref.media, it.moneda) : '—'}</span></div>
        <div class="qa-fact"><span class="qa-k">Garantía</span><span class="qa-v">${it.garantia ? dinero(it.garantia, it.moneda) : '—'}</span></div>
        <div class="qa-fact"><span class="qa-k">Tipo</span><span class="qa-v">${esc(it.tipo) || '—'}</span></div>
        <div class="qa-fact"><span class="qa-k">Capacidad</span><span class="qa-v">${it.huespedes ? `${it.huespedes} huésp.` : '—'}${it.m2 ? ` · ${it.m2} m²` : ''}</span></div>
        <div class="qa-fact${it.coords ? '' : ' is-bad'}"><span class="qa-k">Ubicación</span><span class="qa-v">${it.coords ? 'Con coordenadas' : 'Sin coordenadas'}</span></div>
        <div class="qa-fact${it.publicado ? '' : ' is-bad'}"><span class="qa-k">En el feed</span><span class="qa-v">${it.publicado ? 'Disponible' : 'No disponible'}</span></div>
    </div>`;

    const est = estados(it), okN = est.filter(x => x.e === 'ok').length;
    const pend = est.find(x => x.e !== 'ok');
    const IR = { ubicacion: 'precio' };   // la ubicación se ve en la sección de precio
    const indice = `<nav class="qa-dnav" aria-label="Campos de la ficha">
        <div class="qa-dnav-top">
            <span class="qa-dnav-sum"><b>${okN} de ${est.length}</b> campos bien</span>
            <span class="qa-dnav-bar" aria-hidden="true"><i style="width:${okN / est.length * 100}%"></i></span>
            ${pend ? `<button type="button" class="qa-dnav-next" data-act="ir-sec" data-v="${IR[pend.k] || pend.k}" id="qa-d-pend">Ir a ${esc(pend.t.toLowerCase())} ${I.chevR}</button>` : `<span class="qa-dnav-done">${I.check} Ficha completa</span>`}
        </div>
        <div class="qa-dnav-chips">${est.map(x => `<button type="button" class="qa-dnav-chip is-${x.e}" data-act="ir-sec" data-v="${IR[x.k] || x.k}" id="qa-d-ir-${x.k}"><i aria-hidden="true">${MARCA_E[x.e]}</i>${esc(x.t)}<span class="bk-sr-only">: ${TXT_E[x.e]}</span></button>`).join('')}</div>
    </nav>`;

    const precioEst = e('ubicacion').e === 'bad' && e('precio').e === 'ok' ? e('ubicacion') : e('precio');

    return `<div class="qa-layer" role="presentation">
        <div class="qa-drawer-bg" data-act="cerrar"></div>
        <div class="qa-drawer" role="dialog" aria-modal="true" aria-labelledby="qa-d-title" tabindex="-1">
            <header class="qa-drawer-head">
                <div class="qa-drawer-nav">
                    <span class="qa-drawer-pos">${pos + 1} de ${lista.length}</span>
                    <button type="button" class="qa-ib" data-act="abrir" data-id="${ant ? ant.id : ''}" id="qa-d-ant" ${ant ? '' : 'disabled'} aria-label="Anterior (←)" title="Anterior (←)">${I.chevL}</button>
                    <button type="button" class="qa-ib" data-act="abrir" data-id="${sig ? sig.id : ''}" id="qa-d-sig" ${sig ? '' : 'disabled'} aria-label="Siguiente (→)" title="Siguiente (→)">${I.chevR}</button>
                    <button type="button" class="qa-x" data-act="cerrar" aria-label="Cerrar (Esc)">×</button>
                </div>
                <h2 class="qa-drawer-title" id="qa-d-title">${esc(it.nombre)}</h2>
                <p class="qa-drawer-sub"><code>${esc(it.idcodigo)}</code>${it.idalojamiento ? ` · alojamiento ${it.idalojamiento}` : ''} · ${esc(it.direccion)}</p>
                <div class="qa-drawer-tags">${S.soloVer ? `
                    <span class="bk-badge ${it.publicado ? 'bk-badge--ok' : 'bk-badge--plain'}">${it.publicado ? 'Publicado' : 'Oculto'}</span>
                    ${it.publicado && !pub.ok ? `<span class="bk-badge bk-badge--bad">Se vería mal · ${esc(pub.motivo)}</span>` : ''}` : `
                    <span class="bk-badge ${it.accion === 'nuevo' ? 'bk-badge--pay' : ''}">${it.accion === 'nuevo' ? 'Nuevo' : 'Se actualiza'}</span>
                    <span class="bk-badge ${pub.ok ? 'bk-badge--ok' : 'bk-badge--bad'}">${pub.ok ? 'Quedaría publicado' : `Entraría oculto · ${esc(pub.motivo)}`}</span>
                    <label class="qa-switch">
                        <input type="checkbox" data-act="incluir" data-id="${it.id}" id="qa-d-inc"${it.incluido ? ' checked' : ''} />
                        <span class="qa-switch-ui" aria-hidden="true"></span><span>${it.incluido ? 'Se integra' : 'No se integra'}</span>
                    </label>`}
                </div>
                ${indice}
            </header>
            <div class="qa-drawer-body">
                ${seccion(`Fotos (${act.length} de ${it.fotos.length})`, e('fotos'), fotos, mal.length && !S.soloVer ? `<button type="button" class="bk-btn bk-btn--ghost" data-act="quitar-marcadas" id="qa-d-quitar">${I.trash} Quitar las ${mal.length} marcadas</button>` : '', 'fotos')}
                ${seccion('Precio, ubicación y datos', precioEst, hechos, '', 'precio')}
                ${seccion(`Amenidades (${it.columnas.length})`, e('amenidades'), bloqueAmen(it), '', 'amenidades')}
                ${it.cantLista.length ? seccion('Camas, baños y capacidad', e('camas'), bloqueCant(it), '', 'camas') : ''}
                ${CAMPOS_TXT.map(k => seccionTexto(it, k, e(k))).join('')}
            </div>
        </div>
    </div>`;
}

// ── Capas: corrida en curso, confirmaciones ────────────────────────────
/*
 * La corrida en curso no se pinta acá: la muestra CentroQa.vue con el loader
 * de House & Flats (HyFLoader), igual que el resto del sitio. Esta función
 * describe qué tiene que mostrar: título, paso, avance, resultado y botones.
 */
function estadoCorrida() {
    const k = S.capa, c = k.corrida;
    const int = intDe(k.clave || (c && c.integracion)) || k.int || { nombre: '' };
    const corriendo = !c || ['corriendo', 'integrando'].includes(c.estado);
    const titulo = !c ? 'Lanzando…' : {
        corriendo: c.tipo === 'prueba' ? 'Corriendo en modo prueba' : 'Corriendo', integrando: 'Integrando',
        revision: 'Corrida de prueba lista', integrada: `${int.nombre} integrada`, ok: 'Terminó bien', fallida: 'No terminó bien', descartada: 'Corrida descartada',
    }[c.estado] || c.estado;
    const mal = !!c && c.estado === 'fallida';
    let acciones;
    if (corriendo) acciones = [{ t: 'Seguir en segundo plano', act: 'cerrar' }];
    else if (c.estado === 'revision') acciones = [{ t: 'Ver la revisión', nav: c.integracion, primario: true }];
    else if (c.estado === 'integrada') acciones = [{ t: 'Ver la integración', nav: `${c.integracion}/actual` }, { t: 'Elegir la hora', act: 'tras-integrar', primario: true }];
    else if (c.estado === 'ok') acciones = [{ t: 'Cerrar', act: 'cerrar' }, { t: 'Ver la integración', nav: `${c.integracion}/actual`, primario: true }];
    else acciones = [{ t: 'Cerrar', act: 'cerrar', primario: true }];
    const d = c && c.resumen && c.resumen.decisiones;
    return {
        modo: 'corrida',
        estado: corriendo ? 'curso' : mal ? 'error' : 'ok',
        titulo,
        sub: int.nombre || '',
        paso: (c && c.paso) || 'Esperando al servidor',
        pct: c ? Math.max(0, Math.min(100, Number(c.pct) || 0)) : 0,
        resumen: d ? [['Excluidos', d.excluidos], ['Fotos quitadas', d.fotos], ['Textos corregidos', d.textos], ['Amenidades corregidas', d.amenidades]].map(([t, n]) => ({ t, n: num(n) })) : null,
        detalle: mal ? motivoError(c) : '',
        acciones,
    };
}
/** Por qué falló, en pocas líneas: las del log que hablan de error o, si no hay, las últimas. */
function motivoError(c) {
    const lineas = String(c.log || '').split('\n').map(l => l.trim()).filter(Boolean);
    const err = lineas.filter(l => /error|falló|fallo|exception|no se pudo|rechaz/i.test(l));
    return (err.length ? err : lineas).slice(-3).join('\n') || c.paso || '';
}
/** Lo que tiene que mostrar el loader ahora (null = nada). */
function estadoCarga() {
    if (S.capa && S.capa.tipo === 'corrida') return estadoCorrida();
    if (S.error) return null;
    if (S.vista === 'revision' && S.cargando) return { modo: 'carga', texto: 'Cargando la corrida…' };
    if (S.vista === 'historial' && !S.hist) return { modo: 'carga', texto: 'Cargando el historial…' };
    if (S.vista !== 'revision' && S.vista !== 'historial' && !S.ints) return { modo: 'carga', texto: 'Cargando integraciones…' };
    return null;
}
function avisarCarga() {
    if (opciones.carga) opciones.carga(estadoCarga());
}
function vConfirmar() {
    const k = S.capa;
    return `<div class="qa-layer qa-modal" role="presentation">
        <div class="qa-drawer-bg" data-act="cerrar"></div>
        <div class="qa-modal-card" role="dialog" aria-modal="true" aria-labelledby="qa-cf-t" tabindex="-1">
            <button type="button" class="qa-x" data-act="cerrar" aria-label="Cerrar">×</button>
            <div class="qa-modal-ico${k.peligro ? ' qa-modal-ico--danger' : ''}">${k.ico || I.upload}</div>
            <h2 class="qa-modal-title" id="qa-cf-t">${esc(k.titulo)}</h2>
            <p class="qa-modal-text">${k.texto}</p>
            ${k.lista || ''}
            <div class="qa-modal-acts">
                <button type="button" class="bk-btn bk-btn--ghost" data-act="cerrar" id="qa-cf-no">${esc(k.no || 'Volver')}</button>
                <button type="button" class="bk-btn ${k.peligro ? 'bk-btn--danger' : 'bk-btn--primary'}" data-act="confirmar" id="qa-cf-si">${esc(k.si)}</button>
            </div>
        </div>
    </div>`;
}
function vDueno() {
    const k = S.capa, int = intDe(k.clave);
    const lista = k.cargando ? '<p class="qa-dueno-vacio">Buscando…</p>'
        : k.q.trim().length < 2 ? '<p class="qa-dueno-vacio">Escribe al menos 2 letras del correo o del nombre, o el id.</p>'
            : !k.res.length ? '<p class="qa-dueno-vacio">Ningún usuario coincide.</p>'
                : `<ul class="qa-dueno-lista" aria-label="Usuarios">${k.res.map(u => `<li><button type="button" class="qa-dueno-op${int.dueno && int.dueno.id === u.id ? ' is-on' : ''}" data-act="elegir-dueno" data-id="${u.id}">
                    <span class="qa-dueno-n">${esc(u.nombre || u.correo)}${u.tipo !== 'anfitrion' ? ` <em>${esc(u.tipo)}</em>` : ''}</span>
                    <span class="qa-dueno-c">${esc(u.correo)} · #${u.id}</span></button></li>`).join('')}</ul>`;
    return `<div class="qa-layer qa-modal" role="presentation">
        <div class="qa-drawer-bg" data-act="cerrar"></div>
        <div class="qa-modal-card" role="dialog" aria-modal="true" aria-labelledby="qa-du-t" tabindex="-1">
            <button type="button" class="qa-x" data-act="cerrar" aria-label="Cerrar">×</button>
            <div class="qa-modal-ico">${I.user}</div>
            <h2 class="qa-modal-title" id="qa-du-t">¿A qué anfitrión se cargan?</h2>
            <p class="qa-modal-text">Los alojamientos de <b>${esc(int.nombre)}</b> quedan a nombre de este usuario: los ve en su panel y recibe sus reservas.</p>
            <label class="bk-search qa-dueno-buscar">${I.search}<span class="bk-sr-only">Buscar usuario</span>
                <input id="qa-du-q" type="search" placeholder="Correo, nombre o id" value="${esc(k.q)}" data-act="buscar-dueno" autocomplete="off" />
            </label>
            <div id="qa-du-res">${lista}</div>
        </div>
    </div>`;
}
let buscarDuenoT = null;
async function buscarDueno() {
    const k = S.capa;
    if (!k || k.tipo !== 'dueno') return;
    const q = k.q.trim();
    if (q.length < 2) { k.res = []; k.cargando = false; pintarCapa(); return; }
    try {
        const d = await api.get(`/usuarios?q=${encodeURIComponent(q)}`);
        if (S.capa === k && k.q.trim() === q) { k.res = d.usuarios; k.cargando = false; pintarCapa(); }
    } catch (e) { if (S.capa === k) { k.cargando = false; k.res = []; pintarCapa(); aviso(msgErr(e), null, true); } }
}
/** Guarda el anfitrión. Si ya hay alojamientos cargados, la API pide confirmar que pasan al nuevo. */
async function guardarDueno(clave, u, mover) {
    const int = intDe(clave);
    try {
        const d = await api.patch(`/integraciones/${clave}`, { idusuario: u.id, mover: !!mover });
        S.ints = S.ints.map(i => (i.clave === clave ? d.integracion : i));
        render();
        aviso(d.movidos ? `${num(d.movidos)} alojamientos pasaron a ${u.correo}.` : `${int.nombre} se carga en ${u.correo}.`);
    } catch (e) {
        if (e.status === 409 && e.data && e.data.alojamientos) {
            const anterior = int.dueno ? int.dueno.correo : 'el anfitrión actual';
            S.capa = {
                tipo: 'confirmar', ico: I.user, titulo: `¿Pasar los alojamientos a ${u.correo}?`, si: `Pasar ${num(e.data.alojamientos)} alojamientos`,
                texto: `${esc(int.nombre)} ya tiene <b>${num(e.data.alojamientos)} alojamientos</b> cargados con ${esc(anterior)}. Pasan todos a <b>${esc(u.correo)}</b>, con sus fotos, calendario y lo que corrigió QA, y las próximas corridas siguen cargando en él. Las reservas que ya existen no cambian.`,
                fn: () => guardarDueno(clave, u, true),
            };
            abrirCapa();
            return;
        }
        aviso(msgErr(e), null, true);
    }
}

function vCapa() {
    const k = S.capa;
    if (!k) return '';
    if (k.tipo === 'dueno') return vDueno();
    if (k.tipo === 'item') return S.c ? vItem(k.id) : '';
    if (k.tipo === 'corrida') return ''; // la muestra el loader (estadoCorrida)
    if (k.tipo === 'confirmar') return vConfirmar();
    return '';
}

// ── Pintado ────────────────────────────────────────────────────────────
const capasEl = document.createElement('div');
const avisoEl = document.createElement('div');
const appEl = document.createElement('div');
avisoEl.className = 'qa-aviso';
avisoEl.setAttribute('aria-live', 'polite');
raiz.appendChild(appEl); raiz.appendChild(capasEl); raiz.appendChild(avisoEl);

function recordarFoco(root) {
    const a = document.activeElement;
    return { capa: !!root.firstElementChild, id: a && root.contains(a) ? a.id : null, sel: a && a.selectionStart };
}
function restaurarFoco(f, root) {
    if (!f.id) { if (f.capa) { const d = root.querySelector('[role="dialog"]'); if (d && !root.contains(document.activeElement)) d.focus({ preventScroll: true }); } return; }
    const el = document.getElementById(f.id);
    if (!el) { const d = root.querySelector('[role="dialog"]'); if (d) d.focus({ preventScroll: true }); return; }
    el.focus({ preventScroll: true });
    if (f.sel != null && el.setSelectionRange) try { el.setSelectionRange(f.sel, f.sel); } catch (e) { /* type=search */ }
}
function render() {
    const html = S.vista === 'revision' ? vRevision() : S.vista === 'historial' ? vHistorial() : vInicio();
    const foco = recordarFoco(appEl);
    const clave = `${S.vista}:${S.clave}`;
    const misma = S.vistaPrevia === clave;
    appEl.innerHTML = html;
    if (misma) appEl.querySelectorAll('.bk-side, .qa-card, .qa-int, .bk-toolbar').forEach(el => { el.style.animation = 'none'; });
    S.vistaPrevia = clave;
    restaurarFoco(foco, appEl);
    avisarCarga();
}
function pintarCapa() {
    const foco = recordarFoco(capasEl);
    const scroll = capasEl.querySelector('.qa-drawer-body');
    const top = scroll ? scroll.scrollTop : 0;
    const log = capasEl.querySelector('#qa-log');
    const alFondo = !log || log.scrollTop + log.clientHeight >= log.scrollHeight - 8;
    capasEl.innerHTML = vCapa();
    const nuevo = capasEl.querySelector('.qa-drawer-body');
    if (nuevo) nuevo.scrollTop = top;
    const nuevoLog = capasEl.querySelector('#qa-log');
    if (nuevoLog && alFondo) nuevoLog.scrollTop = nuevoLog.scrollHeight;
    if (foco.capa) capasEl.querySelectorAll('.qa-drawer, .qa-drawer-bg, .qa-modal-card').forEach(el => { el.style.animation = 'none'; });
    restaurarFoco(foco, capasEl);
    avisarCarga();
}
function abrirCapa() {
    if (!S.focoPrevio) S.focoPrevio = document.activeElement;
    document.documentElement.style.overflow = 'hidden';
    pintarCapa();
    const dlg = capasEl.querySelector('[role="dialog"]');
    if (dlg) dlg.focus({ preventScroll: true });
}
function cerrarCapa() {
    guardarBorrador();
    clearInterval(pollCapa); pollCapa = null;
    S.capa = null;
    capasEl.innerHTML = '';
    document.documentElement.style.overflow = '';
    render();
    const f = S.focoPrevio; S.focoPrevio = null;
    if (f && document.body.contains(f)) f.focus({ preventScroll: true });
    else if (f && f.id && document.getElementById(f.id)) document.getElementById(f.id).focus({ preventScroll: true });
}
function aviso(texto, accion, error) {
    avisoEl.innerHTML = `<div class="bk-toast${error ? ' bk-toast--error' : ''}" role="status"><span class="bk-toast-icon" aria-hidden="true">${error ? '!' : '✓'}</span><p class="bk-toast-text">${esc(texto)}</p>${accion ? `<button type="button" class="bk-toast-retry bk-toast-retry--ok" data-act="${accion}">Deshacer</button>` : ''}</div>`;
    clearTimeout(aviso.t);
    aviso.t = setTimeout(() => { avisoEl.innerHTML = ''; }, accion ? 8000 : error ? 6000 : 2600);
}

// ── Datos ──────────────────────────────────────────────────────────────
async function cargarInts() {
    const d = await api.get('/integraciones');
    S.ints = d.integraciones;
    programarPollInts();
}
/** Mientras algo corre, la pantalla de integraciones se refresca sola. */
function programarPollInts() {
    clearInterval(pollInts); pollInts = null;
    if (S.vista !== 'inicio' || !S.ints) return;
    const rapido = S.ints.some(i => i.en_curso);
    pollInts = setInterval(async () => {
        if (S.capa || document.hidden) return;
        try { const d = await api.get('/integraciones'); S.ints = d.integraciones; if (S.vista === 'inicio') render(); if (!S.ints.some(i => i.en_curso) && rapido) programarPollInts(); } catch (e) { /* el próximo */ }
    }, rapido ? 4000 : 30000);
}
async function cargarRevision(r) {
    S.c = null; S.cargando = true; render();
    try {
        if (!S.ints) await cargarInts();
        const int = intDe(S.clave);
        if (int && int.en_revision) {
            const d = await api.get(`/corridas/${int.en_revision.id}?items=1`);
            if (r !== seqRuta) return;
            S.c = { ...d.corrida, items: (d.items || []).map(adaptarItem) };
        }
    } catch (e) { if (r !== seqRuta) return; S.error = msgErr(e); }
    S.cargando = false;
    render();
}

/** "Ver integración": lo que la integración tiene hoy en la base (solo lectura). */
async function cargarActual(r) {
    S.c = null; S.cargando = true; render();
    try {
        const d = await api.get(`/integraciones/${S.clave}/alojamientos`);
        if (r !== seqRuta) return;
        S.ints = [d.integracion];
        S.c = { id: null, creada: d.generado, terminada: d.generado, resumen: null, items: (d.items || []).map(adaptarItem) };
    } catch (e) { if (r !== seqRuta) return; S.error = e && e.status === 404 ? 'Esa integración no existe.' : msgErr(e); }
    S.cargando = false;
    render();
}

/** Abre la capa de una corrida y la sigue hasta que termine. */
function seguirCorrida(id, clave) {
    // `int`: copia para el encabezado. Al terminar se vacía S.ints para recargarla
    // y, sin la copia, la capa pintaba el logo "?" sin nombre.
    S.capa = { tipo: 'corrida', id, clave, corrida: null, int: intDe(clave) };
    abrirCapa();
    const k = S.capa;
    const tick = async () => {
        try {
            const d = await api.get(`/corridas/${id}`);
            if (S.capa !== k) return;
            k.corrida = d.corrida;
            pintarCapa();
            if (!['corriendo', 'integrando'].includes(d.corrida.estado)) {
                clearInterval(pollCapa); pollCapa = null;
                S.ints = null; cargarInts().then(() => { if (S.vista === 'inicio') render(); }).catch(() => {});
                const b = capasEl.querySelector('#qa-run-ver'); if (b) b.focus({ preventScroll: true });
            }
        } catch (e) { /* se reintenta en el próximo */ }
    };
    clearInterval(pollCapa);
    tick();
    pollCapa = setInterval(tick, 1500);
}

async function correr(clave, tipo) {
    try {
        const d = await api.post(`/integraciones/${clave}/correr`, { tipo });
        seguirCorrida(d.corrida_id, clave);
    } catch (e) {
        aviso(msgErr(e), null, true);
        if (e && e.data && e.data.corrida_id) opciones.navegar(clave);
    }
}
async function cambiarIntegracion(clave, cambios, ok) {
    try {
        const d = await api.patch(`/integraciones/${clave}`, cambios);
        S.ints = S.ints.map(i => (i.clave === clave ? d.integracion : i));
        render();
        aviso(ok);
    } catch (e) { aviso(msgErr(e), null, true); }
}

// ── Edición de textos ──────────────────────────────────────────────────
function guardarTexto(it, k, valor) {
    const t = it.textos[k];
    t.copiadoDe = null;
    t.valor = String(valor).trim();
    t.editado = t.valor !== t.original.trim();
    t.v = clasificar(t.valor);
    if (!t.editado) t.valor = t.original;
}
/**
 * "Ver integración": escribe ya en la base (QaController@editar) y las columnas
 * quedan fijadas. Devuelve si salió bien; si no, avisa y quien llama deshace.
 */
async function enVivo(items, cambios) {
    enVuelo++;
    try {
        await api.post(`/integraciones/${S.clave}/editar`, { ids: items.map(i => i.id), ...cambios });
        const cols = [...Object.keys(cambios.textos || {}), ...Object.keys(cambios.amenidades || {}), ...Object.keys(cambios.cantidades || {})];
        items.forEach(i => cols.forEach(c => i.fijados.add(c)));
        return true;
    } catch (e) {
        aviso(`No se guardó: ${msgErr(e)}`, null, true);
        return false;
    } finally {
        enVuelo--;
        if (S.capa && S.capa.tipo === 'item') pintarCapa();
        render();
    }
}
/**
 * Cambia una cantidad (camas, baños…) del alojamiento abierto. En "Ver
 * integración" se escribe con un respiro: varios clics en + seguidos = un solo POST.
 */
const cantVivo = { t: null, previo: null };
function cambiarCant(col, valor) {
    const it = itemAbierto(); if (!it) return;
    const c = it.cantLista.find(x => x.col === col); if (!c) return;
    const v = Math.max(0, Math.min(c.max, Math.round(+valor) || 0));
    if (v === it.cant[col]) { pintarCapa(); return; }
    if (S.soloVer && !cantVivo.t) cantVivo.previo = { ...it.cant };
    it.cant = { ...it.cant, [col]: v };
    if (S.capa.sel) delete S.capa.sel.__cant;   // cambió lo que se aplicaría a otros
    guardar(it); pintarCapa(); render();
    if (!S.soloVer) return;
    clearTimeout(cantVivo.t);
    cantVivo.t = setTimeout(async () => {
        const previo = cantVivo.previo, cambios = {};
        cantVivo.t = null; cantVivo.previo = null;
        Object.keys(it.cant).forEach(k => { if (it.cant[k] !== previo[k]) cambios[k] = it.cant[k]; });
        if (Object.keys(cambios).length && !(await enVivo([it], { cantidades: cambios }))) { it.cant = previo; pintarCapa(); render(); }
    }, 500);
}
/** Un texto de un alojamiento, en vivo; si falla vuelve a como estaba. */
async function textoEnVivo(items, campo, antes) {
    if (await enVivo(items, { textos: { [campo]: items[0].textos[campo].valor } })) return true;
    Object.assign(items[0].textos[campo], antes);
    if (S.capa && S.capa.tipo === 'item') pintarCapa();
    render();
    return false;
}
/** Vuelve en pantalla lo último que se aplicó a otros (S.deshacer). */
function deshacerLocal() {
    const d = S.deshacer; if (!d) return;
    d.antes.forEach(x => {
        const i = itemDe(x.id); if (!i) return;
        if (d.amen) i.columnas = x.columnas; else if (d.cant) i.cant = x.cant; else Object.assign(i.textos[d.campo], x.t);
        guardar(i);
    });
    S.deshacer = null;
    if (S.capa && S.capa.tipo === 'item') pintarCapa();
    render();
}
/** Si se sale del panel con un texto a medio escribir, se guarda (no se pierde). */
function guardarBorrador() {
    const k = S.capa;
    if (!k || k.tipo !== 'item' || !k.editando || !S.c) return;
    const it = S.c.items.find(i => i.id === k.id), t = it && it.textos[k.editando];
    if (t && k.borrador.trim() !== t.valor) {
        const antes = { ...t };
        guardarTexto(it, k.editando, k.borrador);
        guardar(it);
        if (S.soloVer) textoEnVivo([it], k.editando, antes);
        aviso(`Se guardó lo que escribiste en ${TEXTOS[k.editando].toLowerCase()}.`);
    }
    k.editando = null;
}
const itemAbierto = () => S.c && S.capa && S.c.items.find(i => i.id === S.capa.id);
const itemDe = id => S.c && S.c.items.find(i => String(i.id) === String(id));
const focoA = (...ids) => { for (const id of ids) { const el = document.getElementById(id); if (el) { el.focus({ preventScroll: true }); return; } } };

// ── Acciones ───────────────────────────────────────────────────────────
const ACT = {
    'reintentar': () => { S.error = ''; ir(S.vista === 'revision' ? S.clave : S.vista === 'historial' ? 'historial' : ''); },
    'filtro-inicio': el => { S.inicio.filtro = el.dataset.v; render(); },
    'filtro-rev': el => {
        S.rev.filtro = el.dataset.v; S.rev.max = 60;
        if (el.dataset.ir) S.rev.hallazgo = null;
        render();
        if (el.dataset.ir) { const l = $('#qa-lista'); if (l) l.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    },
    'hallazgo': el => {
        const v = el.dataset.v || null;
        S.rev.hallazgo = S.rev.hallazgo === v ? null : v;
        S.rev.max = 60;
        if (v) S.rev.filtro = 'todos';
        render();
        if (v) { const l = $('#qa-lista'); if (l) l.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    },
    'limpiar-rev': () => { S.rev = { filtro: 'todos', hallazgo: null, q: '', max: 60 }; render(); },
    'ver-mas': () => { S.rev.max += 60; render(); },

    // Integraciones
    'correr': el => {
        const clave = el.dataset.clave, tipo = el.dataset.v, int = intDe(clave);
        if (tipo === 'prueba') { correr(clave, 'prueba'); return; }
        S.capa = {
            tipo: 'confirmar', ico: I.refresh, titulo: `¿Correr ${int.nombre} ahora?`, si: 'Correr ahora',
            texto: `Se corre <code>${esc(int.comando)}</code> de verdad: escribe en House &amp; Flats, respetando lo que se decidió en el Centro de QA.`,
            fn: () => correr(clave, 'manual'),
        };
        abrirCapa();
    },
    'ver-corrida': el => seguirCorrida(+el.dataset.id),
    'dueno': el => {
        S.capa = { tipo: 'dueno', clave: el.dataset.clave, q: '', res: [], cargando: false };
        abrirCapa();
        focoA('qa-du-q');
    },
    'elegir-dueno': el => {
        const k = S.capa, u = k && k.res.find(x => x.id === +el.dataset.id);
        if (!u) return;
        const int = intDe(k.clave);
        cerrarCapa();
        if (int.dueno && int.dueno.id === u.id) return;
        guardarDueno(k.clave, u, false);
    },
    'habilitar': el => {
        const clave = el.dataset.clave, int = intDe(clave), hora = ($(`#qa-hora-${clave}`) || {}).value;
        if (!hora) { aviso('Elige primero a qué hora corre.', null, true); focoA(`qa-hora-${clave}`); return; }
        S.capa = {
            tipo: 'confirmar', ico: I.check, titulo: `¿Habilitar ${int.nombre}?`, si: `Habilitar a las ${hora}`,
            texto: int.cada_minutos
                ? `Desde las <b>${esc(hora)}</b> (hora de Chile) corre sola ${cadaTxt(int.cada_minutos).toLowerCase()} y escribe directo, sin pasar por revisión. Lo que excluiste o corregiste se sigue respetando.`
                : `Desde mañana corre sola todos los días a las <b>${esc(hora)}</b> (hora de Chile) y escribe directo, sin pasar por revisión. Lo que excluiste o corregiste se sigue respetando.`,
            fn: () => cambiarIntegracion(clave, { hora, estado: 'habilitada' }, `${int.nombre} habilitada: corre a las ${hora}.`),
        };
        abrirCapa();
    },
    'guardar-hora': el => {
        const clave = el.dataset.clave, hora = ($(`#qa-hora-${clave}`) || {}).value;
        if (!hora) { aviso('Elige una hora.', null, true); return; }
        cambiarIntegracion(clave, { hora }, `Ahora corre a las ${hora}.`);
    },
    'pausar': el => {
        const clave = el.dataset.clave, int = intDe(clave);
        S.capa = {
            tipo: 'confirmar', ico: I.pause, titulo: `¿Pausar ${int.nombre}?`, si: 'Pausar', peligro: true,
            texto: 'Deja de correr sola hasta que la vuelvas a habilitar. La disponibilidad y los precios no se actualizan mientras tanto.',
            fn: () => cambiarIntegracion(clave, { estado: 'pausada' }, `${int.nombre} pausada.`),
        };
        abrirCapa();
    },
    'confirmar': () => { const fn = S.capa && S.capa.fn; cerrarCapa(); if (fn) fn(); },
    'tras-integrar': () => { cerrarCapa(); opciones.navegar(''); },

    // Revisión
    'abrir': el => {
        const it = itemDe(el.dataset.id); if (!it) return;
        guardarBorrador();
        if (!it.visto) { it.visto = true; guardar(it); }
        const yaAbierta = S.capa && S.capa.tipo === 'item';
        S.capa = { tipo: 'item', id: it.id };
        if (yaAbierta) { pintarCapa(); const d = capasEl.querySelector('.qa-drawer-body'); if (d) d.scrollTop = 0; } else abrirCapa();
        render();
    },
    'cerrar': () => {
        const k = S.capa;
        cerrarCapa();
        if (k && k.tipo === 'corrida' && k.corrida && k.corrida.estado === 'integrada' && S.vista !== 'historial') opciones.navegar('');
    },
    'foto': async el => {
        const it = itemAbierto(); if (!it) return;
        const f = it.fotos.find(x => x.id === el.dataset.f), op = el.dataset.op;
        if (op === 'quitar') f.quitada = true;
        if (op === 'restaurar') f.quitada = false;
        if (op === 'ok') f.aceptada = true;
        guardar(it); pintarCapa(); render();
        // "Ver integración": se borra (o vuelve) de la galería ya mismo y queda bloqueada.
        if (S.soloVer && op !== 'ok') {
            enVuelo++;
            try {
                await api.post(`/integraciones/${S.clave}/fotos`, { id: it.id, url: f.src, quitar: op === 'quitar' });
                aviso(op === 'quitar' ? 'Foto quitada: no vuelve aunque la integración corra sola.' : 'La foto volvió a la galería.');
            } catch (e) {
                f.quitada = op !== 'quitar';
                aviso(`No se guardó: ${msgErr(e)}`, null, true);
            } finally {
                enVuelo--;
                if (S.capa && S.capa.tipo === 'item') pintarCapa();
                render();
            }
        }
    },
    'quitar-marcadas': () => {
        const it = itemAbierto(); if (!it) return;
        const n = fotosMarcadas(it).length;
        fotosMarcadas(it).forEach(f => { f.quitada = true; });
        guardar(it); pintarCapa(); render();
        aviso(`Se quitaron ${plural(n, 'foto', 'fotos')}.`);
    },
    'ir-sec': el => { const s = capasEl.querySelector(`#qa-sec-${el.dataset.v}`); if (s) s.scrollIntoView({ behavior: 'smooth', block: 'start' }); },
    'editar': el => {
        const k = S.capa, it = itemAbierto(); if (!it) return;
        guardarBorrador();
        k.editando = el.dataset.v;
        k.borrador = it.textos[k.editando].valor;
        pintarCapa();
        const ta = capasEl.querySelector('#qa-ed-txt');
        if (ta) { ta.focus({ preventScroll: true }); ta.setSelectionRange(ta.value.length, ta.value.length); ta.closest('.qa-sec').scrollIntoView({ behavior: 'smooth', block: 'nearest' }); }
    },
    'usar-sug': () => {
        const k = S.capa, it = itemAbierto(); if (!it) return;
        k.borrador = sinContacto(it.textos[k.editando].original);
        pintarCapa();
        const ta = capasEl.querySelector('#qa-ed-txt'); if (ta) { ta.focus({ preventScroll: true }); ta.setSelectionRange(ta.value.length, ta.value.length); }
    },
    'cancelar-ed': () => {
        const k = S.capa, campo = k.editando;
        k.editando = null;
        pintarCapa();
        focoA(`qa-ed-btn-${campo}`, `qa-ed-vacio-${campo}`);
    },
    'guardar-ed': async () => {
        const k = S.capa, campo = k.editando, it = itemAbierto(); if (!it || !campo) return;
        const antes = { ...it.textos[campo] };
        guardarTexto(it, campo, k.borrador);
        k.editando = null;
        guardar(it); pintarCapa(); render();
        focoA(`qa-ed-btn-${campo}`, `qa-ed-vacio-${campo}`);
        if (S.soloVer && !(await textoEnVivo([it], campo, antes))) return;
        aviso(it.textos[campo].v === 'ok' ? `${TEXTOS[campo]}: texto guardado.` : `${TEXTOS[campo]}: guardado, pero todavía hay algo para revisar.`);
    },
    'quitar-contacto': async el => {
        const it = itemAbierto(), campo = el.dataset.v; if (!it) return;
        const antes = { ...it.textos[campo] };
        guardarTexto(it, campo, sinContacto(it.textos[campo].valor));
        guardar(it); pintarCapa(); render();
        if (S.soloVer && !(await textoEnVivo([it], campo, antes))) return;
        aviso('Se quitaron el teléfono y el correo del texto.');
    },
    'restaurar-txt': el => {
        const it = itemAbierto(), campo = el.dataset.v; if (!it) return;
        guardarTexto(it, campo, it.textos[campo].original);
        guardar(it); pintarCapa(); render();
        focoA(`qa-ed-btn-${campo}`, `qa-ed-vacio-${campo}`);
        aviso('Volvió el texto que trae el feed.');
    },
    // data-modo: faltan (a los que les falta) · todos · sel (los marcados en la lista)
    'aplicar': async el => {
        const k = S.capa, campo = el.dataset.v, modo = el.dataset.modo, it = itemAbierto(); if (!it) return;
        const amen = campo === '__amen', esCant = campo === '__cant';
        const cand = amen ? candidatosAmen(it) : esCant ? candidatosCant(it) : candidatosTexto(it, campo);
        const sel = (k.sel && k.sel[campo]) || [];
        const destino = modo === 'todos' ? cand.otros : modo === 'faltan' ? cand.faltan : cand.otros.filter(i => sel.includes(i.id));
        if (!destino.length) return;
        k.eligiendo = null;
        if (k.sel) delete k.sel[campo];

        if (esCant) {
            const cols = cambiosCant(it), cambios = {};
            cols.forEach(c => { cambios[c] = it.cant[c]; });
            S.deshacer = { cant: true, antes: destino.map(i => ({ id: i.id, cant: { ...i.cant } })), cols };
            destino.forEach(i => { i.cant = { ...i.cant, ...cambios }; guardar(i); });
            pintarCapa(); render();
            if (S.soloVer && !(await enVivo(destino, { cantidades: cambios }))) { deshacerLocal(); return; }
            aviso(`Camas, baños y capacidad: aplicado a ${plural(destino.length, 'alojamiento', 'alojamientos')} más.`, 'deshacer');
            return;
        }

        if (amen) {
            const { agregadas, quitadas } = cambiosAmen(it);
            S.deshacer = { amen: true, antes: destino.map(i => ({ id: i.id, columnas: i.columnas.slice() })), cols: [...agregadas, ...quitadas] };
            destino.forEach(i => {
                const orden = i.amenLista.map(a => a.col);
                i.columnas = orden.filter(c => (i.columnas.includes(c) || agregadas.includes(c)) && !quitadas.includes(c));
                guardar(i);
            });
            pintarCapa(); render();
            if (S.soloVer) {
                const cambios = {};
                agregadas.forEach(c => { cambios[c] = 1; });
                quitadas.forEach(c => { cambios[c] = 0; });
                if (!(await enVivo(destino, { amenidades: cambios }))) { deshacerLocal(); return; }
            }
            aviso(`Amenidades: el cambio se aplicó a ${plural(destino.length, 'alojamiento', 'alojamientos')} más.`, 'deshacer');
            return;
        }

        S.deshacer = { campo, antes: destino.map(i => ({ id: i.id, t: { ...i.textos[campo] } })) };
        destino.forEach(i => { guardarTexto(i, campo, it.textos[campo].valor); i.textos[campo].copiadoDe = it.id; guardar(i); });
        pintarCapa(); render();
        focoA(`qa-ed-btn-${campo}`);
        if (S.soloVer && !(await enVivo(destino, { textos: { [campo]: it.textos[campo].valor } }))) { deshacerLocal(); return; }
        aviso(`${TEXTOS[campo]}: aplicado a ${plural(destino.length, 'alojamiento', 'alojamientos')} más.`, 'deshacer');
    },
    'deshacer': async () => {
        const d = S.deshacer; if (!d || !S.c) return;
        deshacerLocal();
        // En vivo hay que volver a escribir lo de antes (queda fijado con ese valor).
        if (S.soloVer) {
            if (d.cant) {
                for (const x of d.antes) {
                    const i = itemDe(x.id); if (!i) continue;
                    const cambios = {};
                    d.cols.forEach(c => { cambios[c] = x.cant[c] || 0; });
                    await enVivo([i], { cantidades: cambios });
                }
            } else if (d.amen) {
                for (const x of d.antes) {
                    const i = itemDe(x.id); if (!i) continue;
                    const cambios = {};
                    d.cols.forEach(c => { cambios[c] = x.columnas.includes(c) ? 1 : 0; });
                    await enVivo([i], { amenidades: cambios });
                }
            } else {
                const porValor = {};
                d.antes.forEach(x => { (porValor[x.t.valor] = porValor[x.t.valor] || []).push(itemDe(x.id)); });
                for (const [valor, items] of Object.entries(porValor)) await enVivo(items.filter(Boolean), { textos: { [d.campo]: valor } });
            }
        }
        aviso(`Se deshizo: ${plural(d.antes.length, 'alojamiento vuelve', 'alojamientos vuelven')} a como estaba${d.antes.length > 1 ? 'n' : ''}.`);
    },
    'elegir-aplicar': el => { const k = S.capa; k.eligiendo = k.eligiendo === el.dataset.v ? null : el.dataset.v; pintarCapa(); },
    // "Solo a este": la corrección ya está en este alojamiento; se cierra la oferta de copiarla.
    'no-aplicar': el => {
        const k = S.capa, campo = el.dataset.v;
        k.noAplicar = [...(k.noAplicar || []), campo];
        pintarCapa();
        focoA(`qa-ed-btn-${campo}`);
        aviso(campo === '__amen' ? 'Las amenidades quedan cambiadas solo en este alojamiento.' : campo === '__cant' ? 'Camas, baños y capacidad: quedan solo en este alojamiento.' : `${TEXTOS[campo]}: queda solo en este alojamiento.`);
    },
    'cant': el => { const it = itemAbierto(); if (it) cambiarCant(el.dataset.v, (it.cant[el.dataset.v] || 0) + (+el.dataset.d)); },
    'amen': async el => {
        const it = itemAbierto(); if (!it) return;
        const col = el.dataset.v, orden = it.amenLista.map(a => a.col), antes = it.columnas.slice();
        const on = !it.columnas.includes(col);
        it.columnas = on ? orden.filter(x => x === col || it.columnas.includes(x)) : it.columnas.filter(x => x !== col);
        if (S.capa.sel) delete S.capa.sel.__amen;   // cambió lo que se aplicaría a otros
        guardar(it); pintarCapa(); render();
        if (S.soloVer && !(await enVivo([it], { amenidades: { [col]: on ? 1 : 0 } }))) {
            it.columnas = antes; pintarCapa(); render();
        }
    },

    // Integrar / descartar
    'integrar': () => {
        const int = intDe(S.clave), R = resumen(S.c);
        S.capa = {
            tipo: 'confirmar', ico: I.upload, titulo: `¿Integrar ${int.nombre}?`, si: `Integrar ${num(R.incluidos)}`, no: 'Seguir revisando',
            texto: `Se corre <code>${esc(int.comando)}</code> de verdad. Lo que decidiste queda fijo y se respeta también cuando corra sola.`,
            lista: `<ul class="qa-confirm-list">
                <li><span>Alojamientos nuevos</span><b>${num(R.nuevos)}</b></li>
                <li><span>Se actualizan</span><b>${num(R.actualiza)}</b></li>
                <li><span>Quedarían publicados</span><b>${num(R.publican)}</b></li>
                <li><span>Quedarían ocultos</span><b>${num(R.ocultos)}</b></li>
                <li><span>Excluidos (no entran; si ya estaban, se ocultan)</span><b>${num(R.excluidos)}</b></li>
                <li><span>Fotos quitadas</span><b>${num(R.quitadas)}</b></li>
                <li><span>Textos corregidos</span><b>${num(R.textos)}</b></li>
                <li><span>Amenidades cambiadas</span><b>${num(R.amen)}</b></li>
                <li><span>Camas, baños y capacidad</span><b>${num(R.cant)}</b></li>
                ${R.pendientes ? `<li class="is-bad"><span>Fotos marcadas sin decidir (se suben)</span><b>${num(R.pendientes)}</b></li>` : ''}
            </ul>`,
            fn: async () => {
                try {
                    await vaciarPendientes();
                    const id = S.c.id, clave = S.clave;
                    await api.post(`/corridas/${id}/integrar`);
                    // La revisión ya no se puede tocar: se vuelve a las integraciones
                    // con el avance encima.
                    seguirCorrida(id, clave);
                    opciones.navegar('');
                } catch (e) { aviso(msgErr(e), null, true); }
            },
        };
        abrirCapa();
    },
    'descartar': () => {
        const int = intDe(S.clave);
        S.capa = {
            tipo: 'confirmar', ico: I.trash, peligro: true, titulo: '¿Descartar la corrida?', si: 'Descartar',
            texto: `No se sube nada de ${esc(int.nombre)} y se pierde lo que revisaste en esta corrida.`,
            fn: async () => {
                try {
                    pendientes.forEach(tm => clearTimeout(tm)); pendientes.clear();
                    await api.post(`/corridas/${S.c.id}/descartar`);
                    S.c = null; S.ints = null;
                    aviso(`Corrida de ${int.nombre} descartada.`);
                    opciones.navegar('');
                } catch (e) { aviso(msgErr(e), null, true); }
            },
        };
        abrirCapa();
    },
};

// ── Eventos ── (todos con on(): destruir() los quita)
const quitar = [];
const on = (el, ev, fn, o) => { el.addEventListener(ev, fn, o); quitar.push(() => el.removeEventListener(ev, fn, o)); };
on(raiz, 'click', e => {
    const navEl = e.target.closest('a[data-nav]');
    if (navEl && !e.ctrlKey && !e.metaKey && !e.shiftKey && e.button === 0) {
        e.preventDefault();
        irA(navEl.dataset.nav);
        return;
    }
    const el = e.target.closest('[data-act]');
    if (!el || el.tagName === 'INPUT' || el.tagName === 'TEXTAREA' || el.disabled) return;
    const fn = ACT[el.dataset.act];
    if (fn) { e.preventDefault(); fn(el, e); }
});
on(raiz, 'change', e => {
    const el = e.target;
    if (el.dataset.act === 'incluir') {
        const it = itemDe(el.dataset.id); if (!it) return;
        it.incluido = el.checked;
        guardar(it);
        if (S.capa && S.capa.tipo === 'item') pintarCapa();
        render();
    }
    if (el.dataset.act === 'cant-in') cambiarCant(el.dataset.v, el.value);
    if (el.dataset.act === 'aplicar-sel' && S.capa) {
        const k = S.capa, campo = el.dataset.k, id = +el.dataset.id;
        k.sel = k.sel || {};
        const resto = (k.sel[campo] || []).filter(x => x !== id);
        k.sel[campo] = el.checked ? [...resto, id] : resto;
        pintarCapa();
    }
});
on(raiz, 'input', e => {
    const el = e.target;
    if (el.dataset.act === 'buscar-inicio') { S.inicio.q = el.value; render(); }
    if (el.dataset.act === 'buscar-rev') { S.rev.q = el.value; S.rev.max = 60; render(); }
    if (el.dataset.act === 'buscar-dueno' && S.capa && S.capa.tipo === 'dueno') {
        // Solo se repinta la lista: repintar el input le haría perder el cursor.
        S.capa.q = el.value; S.capa.cargando = el.value.trim().length >= 2;
        clearTimeout(buscarDuenoT);
        buscarDuenoT = setTimeout(buscarDueno, 300);
    }
    // Mientras se escribe no se repinta el panel: solo la pista y el contador.
    if (el.dataset.act === 'borrador' && S.capa) {
        S.capa.borrador = el.value;
        const h = capasEl.querySelector('#qa-ed-hint'), n = capasEl.querySelector('#qa-ed-n');
        if (h) h.innerHTML = pista(el.value);
        if (n) n.textContent = `${num(el.value.trim().length)} caracteres`;
    }
});
on(document, 'keydown', e => {
    const k = S.capa;
    if (!k) return;
    const dlg = capasEl.querySelector('[role="dialog"]');
    if (k.tipo === 'item' && k.editando) {
        if (e.key === 'Escape') { e.preventDefault(); ACT['cancelar-ed'](); return; }
        if (e.key === 'Enter' && (e.ctrlKey || e.metaKey)) { e.preventDefault(); ACT['guardar-ed'](); return; }
    }
    if (e.key === 'Escape') { e.preventDefault(); ACT.cerrar(); return; }
    if (k.tipo === 'item' && (e.key === 'ArrowLeft' || e.key === 'ArrowRight') && !/INPUT|TEXTAREA/.test(document.activeElement.tagName)) {
        const b = capasEl.querySelector(e.key === 'ArrowLeft' ? '#qa-d-ant' : '#qa-d-sig');
        if (b && !b.disabled) { e.preventDefault(); b.click(); }
        return;
    }
    // Foco atrapado dentro de la capa
    if (e.key === 'Tab' && dlg) {
        const f = [...dlg.querySelectorAll('button:not([disabled]), [href], input:not([disabled]), textarea, summary')].filter(x => x.offsetParent !== null);
        if (!f.length) return;
        const first = f[0], last = f[f.length - 1];
        if (e.shiftKey && (document.activeElement === first || document.activeElement === dlg)) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
});
// Avisar si se cierra la pestaña con cambios sin mandar.
on(window, 'beforeunload', e => { if (pendientes.size || enVuelo) { e.preventDefault(); e.returnValue = ''; } });

// ── Ruta ───────────────────────────────────────────────────────────────
async function ir(vista) {
    const r = ++seqRuta;
    guardarBorrador();
    if (S.capa && S.capa.tipo !== 'corrida') { S.capa = null; capasEl.innerHTML = ''; document.documentElement.style.overflow = ''; S.focoPrevio = null; }
    await vaciarPendientes();
    S.error = '';
    S.soloVer = false;
    if (!vista) {
        S.vista = 'inicio'; S.clave = null; S.c = null;
        render();
        try { await cargarInts(); } catch (e) { S.error = msgErr(e); }
        if (r === seqRuta) render();
    } else if (vista === 'historial') {
        S.vista = 'historial'; S.clave = null; S.hist = null; S.c = null;
        clearInterval(pollInts); pollInts = null;
        render();
        try {
            if (!S.ints) await cargarInts();
            clearInterval(pollInts); pollInts = null;
            const d = await api.get('/historial');
            if (r !== seqRuta) return;
            S.hist = d.corridas;
        } catch (e) { S.error = msgErr(e); }
        if (r === seqRuta) render();
    } else {
        const [clave, sub] = vista.split('/');
        S.vista = 'revision'; S.clave = clave; S.soloVer = sub === 'actual';
        S.rev = { filtro: 'todos', hallazgo: null, q: '', max: 60 };
        clearInterval(pollInts); pollInts = null;
        S.ints = null;
        await (S.soloVer ? cargarActual(r) : cargarRevision(r));
    }
    window.scrollTo(0, 0);
}

/** Navega a otra vista del Centro de QA, cerrando la capa que haya abierta. */
function irA(vista) {
    if (S.capa) { clearInterval(pollCapa); pollCapa = null; S.capa = null; capasEl.innerHTML = ''; document.documentElement.style.overflow = ''; S.focoPrevio = null; avisarCarga(); }
    opciones.navegar(vista);
}

return {
    ir,
    /** Botones del loader de la corrida (CentroQa.vue): una acción o una vista. */
    accion(a) {
        if (a && a.nav !== undefined) irA(a.nav);
        else if (a && ACT[a.act]) ACT[a.act]();
    },
    /** ¿Quedan cambios sin llegar al servidor? (para avisar al salir de la pantalla) */
    ocupado: () => pendientes.size > 0 || enVuelo > 0,
    destruir() {
        vaciarPendientes();
        clearInterval(pollInts); clearInterval(pollCapa); clearTimeout(aviso.t); clearTimeout(buscarDuenoT); clearTimeout(cantVivo.t);
        quitar.forEach(f => f()); quitar.length = 0;
        document.documentElement.style.overflow = '';
        raiz.innerHTML = '';
    },
};
}
